export const CATEGORIES = [
  "restaurant", "cafe", "hotel", "resort", "villa_palace", "hospital",
  "bakery", "laundry", "catering", "supermarket", "cloud_kitchen", "central_kitchen",
];

export const EMIRATES = [
  "dubai", "abu_dhabi", "sharjah", "ajman", "ras_al_khaimah",
  "fujairah", "umm_al_quwain", "al_ain", "other",
];

export const EXPECTED_DATES = [
  "immediately", "1month", "3months", "6months", "not_sure",
];

export const CONTACT_METHODS = ["whatsapp", "call", "email"];

export const STATUSES = [
  "new", "contacted", "quotation_sent", "waiting_customer",
  "approved", "rejected", "closed",
];

export const WHATSAPP_NUMBER = "+97142882777";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER.replace(/\D/g, "")}`;
export const SHOP_URL = "https://www.mariotstore.com";

export const translations = {
  en: {
    brand: "Mariot Kitchen Equipment",
    brandShort: "MARIOT",
    tagline: "Professional Kitchen Equipment & Project Solutions in UAE",
    nav: {
      home: "Home", about: "About", projects: "Projects", brands: "Brands",
      branches: "Branches", blog: "Blog", contact: "Contact", quote: "Get Quote", admin: "Admin",
      design: "Design Your Project",
      shop: "Shop Now",
      how: "How We Work",
      sectors: "Sectors",
      hub: "Business Hub",
      fabrication: "Fabrication",
      maintenance: "Maintenance",
    },
    hero: {
      eyebrow: "COMMERCIAL KITCHEN SPECIALISTS · UAE & GCC",
      title: "Professional Kitchen Equipment & Project Solutions in UAE",
      titleLead: "Turnkey kitchen solutions",
      titleForConnector: "for",
      rotatingWords: ["restaurants.", "hotels & resorts.", "cafés & bakeries.", "villas & palaces."],
      subtitle: "We supply and support commercial kitchen, refrigeration, stainless steel, laundry, and food service projects across UAE and GCC.",
      cta1: "Request Free Quotation",
      cta2: "View Our Projects",
      cta3: "WhatsApp Us",
    },
    stats: { years: "Years of Experience", projects: "Delivered Projects", brands: "Global Brands", emirates: "Emirates Served" },
    intro: {
      title: "Turnkey commercial kitchen solutions",
      body: "For over two decades, Mariot Kitchen Equipment has helped restaurants, hotels, hospitals, catering companies and industrial food businesses across the UAE build kitchens that perform. From single-item supply to complete turn-key projects — we deliver.",
    },
    categoriesSection: { title: "Main Business Categories", subtitle: "Complete equipment solutions for every food service segment." },
    categories: {
      restaurant: "Restaurants", cafe: "Cafés", hotel: "Hotels", resort: "Resorts",
      villa_palace: "Villas & Palaces",
      hospital: "Hospitals", bakery: "Bakeries", laundry: "Laundries", catering: "Catering",
      supermarket: "Supermarkets", cloud_kitchen: "Cloud Kitchens", central_kitchen: "Central Kitchens",
    },
    featured: { title: "Featured Projects", subtitle: "A glimpse of our recent turnkey deliveries across the UAE.", viewAll: "View all projects" },
    brandsSection: { title: "Our Global Brands", subtitle: "We partner with the world's most trusted manufacturers.", viewAll: "View all brands" },
    whyChoose: {
      title: "Why Choose Mariot",
      subtitle: "Reasons our clients trust us with their most important projects.",
      items: [
        { title: "20+ Years Experience", text: "Two decades supplying commercial kitchens across the UAE and GCC." },
        { title: "Trusted Global Brands", text: "Authorized dealer for Rational, Fimar, Inofrigo, Asaki and more." },
        { title: "Complete Project Solutions", text: "From design and BOQ to installation, commissioning and after-sales." },
        { title: "Fast Response", text: "Same-day quotations and dedicated project managers for large accounts." },
        { title: "In-House Fabrication", text: "Custom stainless steel workshop for tables, hoods, shelving and more." },
        { title: "Nationwide Coverage", text: "Branches and service teams across Dubai, Abu Dhabi and Northern Emirates." },
      ],
    },
    ctaSection: {
      title: "Ready to build your next kitchen?",
      subtitle: "Share your project details and receive a professional quotation within 24 hours.",
      button: "Request a Free Quotation",
    },
    shopSection: {
      eyebrow: "ONLINE STORE",
      title: "Shop kitchen equipment online",
      subtitle: "Fast delivery across the UAE. Browse our full catalogue of ready-to-order commercial kitchen equipment, spare parts and accessories.",
      button: "Shop Now",
      badge1: "Fast UAE delivery",
      badge2: "Original brands",
      badge3: "Secure checkout",
    },
    topBar: {
      delivery: "Delivery across all UAE emirates",
      catalogue: "Download Catalogue",
      catalogueMsg: "Hello, I would like to request the Mariot Kitchen Equipment product catalogue.",
      branches: "Our Branches",
    },
    heroChips: ["20+ Years Experience", "Quality Guaranteed", "Fast UAE Delivery"],
    businessHub: {
      eyebrow: "MARIOT BUSINESS HUB",
      title: "Business solutions for restaurants, cafés, hotels, and commercial kitchens",
      subtitle: "Request business support, project quotations, procurement assistance, and expert kitchen equipment guidance from Mariot.",
      items: [
        {
          title: "Business / Trade Account",
          text: "Open a trade account and enjoy ongoing B2B support.",
          cta: "Apply for Account",
          link: "/business-account",
        },
        {
          title: "Kitchen Consultation & Site Visit",
          text: "Free consultation with a specialist and on-site inspection.",
          cta: "Book Consultation",
          link: "/consultation",
        },
        {
          title: "Restaurant & Café Opening",
          text: "End-to-end launch support for new food service businesses.",
          cta: "Start My Project",
          link: "/restaurant-opening",
        },
        {
          title: "Urgent Equipment Request",
          text: "Fast-track supply when your kitchen can't wait.",
          cta: "Send Urgent Request",
          link: "/urgent-request",
        },
      ],
    },
    packages: {
      eyebrow: "TURNKEY SOLUTIONS",
      title: "Packages & Offers",
      subtitle: "Tailored equipment packages for new projects and startups.",
      cta: "Request Package",
      items: [
        { title: "Restaurant Opening", text: "Complete starter package for new restaurants." },
        { title: "Café Equipment", text: "Everything you need to launch a café." },
        { title: "Bakery Solutions", text: "Ovens, mixers and bakery essentials." },
        { title: "Budget Startup", text: "Cost-effective options for new ventures." },
        { title: "Custom Kitchen", text: "Fully tailored commercial kitchen projects." },
      ],
    },
    whyNumbered: {
      eyebrow: "WHY MARIOT",
      title: "Your Trusted Kitchen Partner",
      subtitle: "Two decades of expertise in commercial kitchen equipment across the UAE and GCC.",
      items: [
        { title: "Global Brands", text: "Equipment from 40+ trusted manufacturers." },
        { title: "Commercial Expertise", text: "Specialists in restaurants, hotels and catering." },
        { title: "Expert Team", text: "Technical advisors to guide every purchase." },
        { title: "After-Sales Support", text: "Maintenance, parts and service you can rely on." },
        { title: "Delivery & Installation", text: "Professional logistics across the UAE." },
        { title: "Custom Fabrication", text: "In-house stainless steel built to your specs." },
        { title: "Multiple Branches", text: "Presence across the UAE — always close to you." },
      ],
      numbersTitle: "By the numbers",
      numbers: [
        { value: "500+", label: "Projects Done" },
        { value: "40+", label: "Global Brands" },
        { value: "300+", label: "Happy Clients" },
        { value: "7", label: "Emirates" },
      ],
      tagline: "Serving the UAE's most trusted restaurants, hotels, and food businesses since 2004.",
    },
    brandsMarquee: {
      eyebrow: "SHOP BY BRAND",
      title: "Trusted Global Brands",
      subtitle: "We partner with the world's leading manufacturers.",
      viewAll: "View all brands",
    },
    testimonials: {
      eyebrow: "CLIENT TESTIMONIALS",
      title: "What Our Partners Say",
      subtitle: "Proud to be trusted by hundreds of hotels, restaurants and hospitality venues across the UAE and the Gulf.",
      trust1: "Active Clients",
      trust2: "Average Rating",
      trust3: "Years in Business",
      items: [
        {
          quote: "Mariot has been our kitchen equipment partner for over 7 years. Unmatched product quality and exceptional after-sales support — our entire restaurant chain relies on them.",
          name: "Khalid Al Mansouri",
          role: "Executive Chef, Marriott Dubai",
          initials: "KM",
        },
        {
          quote: "We outfitted our entire commercial kitchen through Mariot. Delivery was on schedule, installation was flawless, and the equipment continues to perform beyond our expectations.",
          name: "Fatima Al Rashidi",
          role: "Operations Director, Hilton Abu Dhabi",
          initials: "FR",
        },
        {
          quote: "From consultation to commissioning, Mariot makes equipping a professional kitchen effortless. Their deep expertise in commercial equipment is second to none in the UAE.",
          name: "Ahmed Qassem",
          role: "F&B Manager, Rotana Hotels Group",
          initials: "AQ",
        },
      ],
    },
    finalBigCta: {
      eyebrow: "READY TO EQUIP YOUR KITCHEN?",
      title: "Need help planning your commercial kitchen?",
      subtitle: "Our team is ready to advise, quote and equip your project from A to Z — from the first sketch to the first plate.",
      btn1: "Request a Quote",
      btn2: "Chat on WhatsApp",
      btn3: "Our Branches",
    },
    projectExtras: { photos: "photos" },
    clientsStrip: {
      title: "TRUSTED BY LEADING UAE HOSPITALITY BRANDS",
    },
    estimator: {
      eyebrow: "INSTANT ESTIMATE",
      title: "Estimate your kitchen project budget",
      subtitle: "Get a rough AED range for your commercial kitchen in seconds — then request a precise quotation from our engineers.",
      bullets: [
        "Ranges based on real UAE project data",
        "Covers equipment, install, and fabrication",
        "Zero commitment — for planning only",
      ],
      widgetTitle: "Project Cost Calculator",
      widgetHint: "Pick sector · size · level",
      sectorLabel: "Sector",
      sizeLabel: "Kitchen Size",
      levelLabel: "Equipment Level",
      resultLabel: "Estimated Budget Range",
      forApprox: "For approximately",
      disclaimer: "Estimate only. Actual quote depends on brand, layout, MEP, and site conditions.",
      cta: "Get Exact Quotation",
    },
    thankYou: {
      eyebrow: "REQUEST RECEIVED",
      title: "Thank you — your request is with us",
      subtitle: "One of our project specialists will review your details and reach out shortly with a tailored proposal.",
      typedSubtitles: {
        business_account: "Our accounts team will verify your trade documents and confirm your account within 48 business hours.",
        consultation: "Our consultation team will confirm your preferred visit slot and prepare a briefing for the meeting.",
        restaurant_opening: "A launch specialist will contact you to plan your opening timeline and next milestones.",
        urgent: "An urgent-response engineer has been notified. Expect a call within the SLA you selected.",
      },
      timelineEyebrow: "WHAT HAPPENS NEXT",
      timelineTitle: "Your project journey — from request to reality",
      steps: [
        { time: "Right now", title: "Request Received", text: "Your details are logged in our project pipeline and assigned to a dedicated specialist." },
        { time: "Within 24 hours", title: "Initial Review", text: "We review your requirements, area, and timeline to prepare a preliminary approach." },
        { time: "Days 1–3", title: "Consultation Call", text: "A specialist contacts you via your preferred channel to align on scope and next steps." },
        { time: "Days 3–7", title: "Detailed Quotation", text: "You receive a full professional quote covering equipment, install, and warranty." },
      ],
      refTitle: "Need to share more details?",
      refText: "Reply on WhatsApp, attach layouts or BOQs, or simply share photos of your space — our team is ready.",
      actionsTitle: "While you wait",
      actionsSubtitle: "Explore our work or chat with our team directly for anything urgent.",
      btnWhatsapp: "Chat on WhatsApp",
      btnProjects: "See Our Projects",
      btnHome: "Back to Home",
    },
    stainlessFactory: {
      eyebrow: "OWN FABRICATION FACTORY · UAE",
      title: "We don't just supply — we manufacture custom stainless steel",
      subtitle: "Custom units built in our own UAE factory to your exact kitchen layout, Grade 304 & 430, precision-welded and finished to hospitality standards.",
      badge1: "Made to Measure",
      badge2: "In-House Welders",
      badge3: "Grade 304 & 430",
      badgeInPhoto: "OUR FACTORY",
      captionInPhoto: "Every seam, every corner — built by our own team.",
      statLabel: "Delivery",
      statValue: "10–14 days",
      cta: "Send Your Drawings",
      items: {
        work_tables: "Work Tables",
        sinks: "Sinks & Wash Units",
        shelves: "Shelves & Racks",
        hoods: "Exhaust Hoods",
        trolleys: "Trolleys & Carts",
        counters: "Counters & Buffets",
        cabinets: "Cabinets",
        custom: "Custom Fabrication",
      },
    },
    fabricationPage: {
      galleryEyebrow: "REAL FABRICATION",
      galleryTitle: "Custom stainless steel — built for real kitchens",
      gallerySubtitle: "Every unit is drawn, welded, polished and delivered by our own team.",
      customBuild: "CUSTOM BUILD",
      specs: [
        { label: "MATERIAL", title: "AISI 304 & 430", text: "Food-grade stainless steel, corrosion-resistant, hospitality standard." },
        { label: "PRECISION", title: "TIG welded joints", text: "Clean seams that pass HACCP hygiene audits without gaps or crevices." },
        { label: "LEAD TIME", title: "10–14 days average", text: "Made-to-measure units ready and delivered within two weeks of approval." },
      ],
    },
    globalReach: {
      eyebrow: "GLOBAL EXPORT · SERVING THE GCC",
      title: "Headquartered in the UAE · Delivering worldwide",
      subtitle: "We supply commercial kitchen equipment across all six GCC countries and export to selected markets in the Middle East, Africa and Asia — with logistics tuned for hospitality timelines.",
      logistics1: "Land Freight",
      logistics2: "Sea Freight",
      logistics3: "Air Freight",
      ctaQuote: "Request Export Quote",
      ctaContact: "Talk to Export Team",
      gccEyebrow: "GCC MARKETS",
      gccTitle: "All 6 GCC countries served directly",
      beyondEyebrow: "BEYOND THE GCC",
      beyondTitle: "Exporting to selected international markets",
      homeBase: "Home Base",
      activeMarket: "Active Market",
      morePlus: "More on request",
      stat1: "Countries Served",
      stat2: "Export Projects",
      stat3: "Support Availability",
    },
    maintenancePromo: {
      eyebrow: "PROFESSIONAL MAINTENANCE · UAE",
      title: "Keep your kitchen running — reduce downtime by up to 75%",
      subtitle: "A dedicated in-house maintenance team, preventive service plans, spare-parts warehouse, and 24/7 emergency call-outs for hotels, restaurants and multi-outlet operators.",
      features: [
        "Preventive maintenance visits",
        "Same-day emergency response",
        "Genuine spare parts warehouse",
        "QR-tagged equipment tracking",
        "Certified technicians per brand",
        "Monthly performance reports",
      ],
      cta: "Explore Maintenance Plans",
      viewPlans: "See Pricing",
      stat1: "Reduction in equipment downtime",
      stat2: "Enhanced equipment lifespan",
      stat3: "Average cost savings on annual maintenance",
    },
    maintenance: {
      eyebrow: "MAINTENANCE & SERVICE PLANS",
      title: "Professional maintenance that keeps your kitchen running",
      subtitle: "In-house technicians, preventive service plans, genuine spare parts, and a smart portal to track every service call and every asset in real time.",
      viewPlans: "See Plans & Pricing",
      requestQuote: "Request Free Site Audit",
      stats: [
        { value: "75%", label: "Downtime", desc: "Reduction in equipment downtime across our client fleet." },
        { value: "50%", label: "Lifespan", desc: "Enhanced equipment lifespan through preventive care." },
        { value: "30%", label: "Cost Savings", desc: "Average savings on annual maintenance vs. break-fix operators." },
      ],
      featuresEyebrow: "PLATFORM & PROCESS",
      featuresTitle: "Everything you need to keep every asset performing",
      featuresSubtitle: "A modern maintenance operation blending certified technicians with a smart portal.",
      features: [
        { title: "Smart Scheduling", text: "Book, reschedule and track every service visit online.", bullets: ["Preventive visits calendar", "Emergency call-outs", "Real-time status updates"] },
        { title: "QR-Tagged Equipment", text: "Every unit gets a QR code with full history in one scan.", bullets: ["Service history", "Manuals & warranty", "Spare-parts lookup"] },
        { title: "Reports & Analytics", text: "Monthly dashboards on uptime, spend, and asset performance.", bullets: ["Downtime trends", "Cost per asset", "Compliance reports"] },
        { title: "Direct Technician Chat", text: "Chat with our engineers directly for advice and updates.", bullets: ["In-portal chat", "Photo & video uploads", "Same-day resolutions"] },
        { title: "Preventive Maintenance", text: "Scheduled care prevents failure before it disrupts your kitchen.", bullets: ["Manufacturer schedules", "Deep cleaning", "Calibration checks"] },
        { title: "Rapid Response", text: "24/7 emergency response with SLA-backed turnaround.", bullets: ["30-min phone response", "Same-day site visit", "Loaner equipment options"] },
      ],
      plansEyebrow: "MAINTENANCE PACKAGES",
      plansTitle: "Choose the plan that fits your operation",
      plansSubtitle: "Transparent tiered plans — upgrade or scale as your operation grows.",
      mostPopular: "Most Popular",
      selectPlan: "Select This Plan",
      plans: [
        {
          key: "essential",
          eyebrow: "ESSENTIAL",
          name: "Essential Care",
          tagline: "Basic preventive service for small operations.",
          priceFrom: "AED 990",
          priceUnit: "/ month",
          priceNote: "For up to 10 units of equipment",
          features: [
            "2 preventive visits per year",
            "Standard business-hour response",
            "48-hour emergency call-out",
            "Basic quarterly report",
            "10% discount on spare parts",
          ],
        },
        {
          key: "professional",
          eyebrow: "PROFESSIONAL",
          name: "Professional Plan",
          tagline: "Comprehensive care for restaurants and cafés.",
          priceFrom: "AED 2,490",
          priceUnit: "/ month",
          priceNote: "For up to 30 units of equipment",
          featured: true,
          features: [
            "4 preventive visits per year",
            "Same-day emergency call-out",
            "QR asset tagging & portal access",
            "Monthly performance report",
            "15% discount on spare parts",
            "Direct technician chat",
          ],
        },
        {
          key: "premium",
          eyebrow: "PREMIUM",
          name: "Premium Fleet",
          tagline: "Full-service SLA for hotels & chains.",
          priceFrom: "AED 6,900",
          priceUnit: "/ month",
          priceNote: "For 30+ units or multi-outlet fleets",
          features: [
            "Monthly preventive visits",
            "4-hour emergency SLA",
            "Full smart portal + analytics",
            "Dedicated account technician",
            "20% discount on spare parts",
            "Loaner equipment during downtime",
            "Staff training sessions",
          ],
        },
      ],
      trust: [
        { value: "24/7", label: "Emergency Support" },
        { value: "500+", label: "Clients Served" },
        { value: "12", label: "Certified Techs" },
        { value: "48h", label: "Parts SLA" },
      ],
      formEyebrow: "REQUEST MAINTENANCE PLAN",
      formTitle: "Get a tailored maintenance offer",
      formSubtitle: "Tell us about your equipment fleet. We'll reply within 24 working hours.",
      selectedPlan: "Preferred Plan",
      company: "Company Name",
      contactName: "Contact Person",
      phone: "Phone / WhatsApp",
      email: "Email",
      equipmentCount: "Equipment Count (approx)",
      outlets: "Number of Outlets",
      emirate: "Emirate",
      notes: "Additional Notes",
      notesHint: "Types of equipment, current maintenance situation, urgency, etc.",
      submit: "Request Quote",
      formFooter: "Includes a free on-site audit for qualifying operations.",
      downloadContract: "Download Sample Contract",
      clientPortal: "Client Portal",
    },
    maintenanceReviews: {
      eyebrow: "REAL MAINTENANCE CLIENTS",
      title: "Trusted by the UAE's busiest kitchens",
      subtitle: "F&B leaders trust Mariot to keep their equipment running — here's what they say.",
      items: [
        {
          quote: "Since switching to Mariot's Professional plan, our unplanned downtime dropped by more than half. The client portal makes tracking every service call effortless.",
          name: "Rania El-Kamal",
          role: "F&B Director, Blue Fig Restaurant Group",
          initials: "RK",
          metricLabel: "Downtime cut",
          metricValue: "-62%",
        },
        {
          quote: "The 4-hour emergency SLA has saved us during two service peaks already. Their technicians are on brand-certified equipment we didn't even know they covered.",
          name: "Faisal Al Hashimi",
          role: "Operations Manager, Emerald Hospitality",
          initials: "FH",
          metricLabel: "SLA response",
          metricValue: "3h 12m",
        },
        {
          quote: "Every asset now has a QR tag with full history. Onboarding a new chef used to take days for equipment training — now it takes a scan.",
          name: "Yara Nassar",
          role: "Executive Chef, Marina Beach Resort",
          initials: "YN",
          metricLabel: "Onboarding faster",
          metricValue: "5x",
        },
        {
          quote: "Predictable monthly maintenance fees replaced random repair bills. We saved almost 30% year-on-year and got better service.",
          name: "Marwan Hassan",
          role: "CFO, Levantine Kitchens Group",
          initials: "MH",
          metricLabel: "Annual savings",
          metricValue: "-28%",
        },
      ],
    },
    emergencyLine: {
      compactLabel: "Emergency Line",
      eyebrow: "24/7 EMERGENCY MAINTENANCE",
      title: "Kitchen down? Reach our on-call engineer now.",
      subtitle: "For active maintenance plan holders — direct WhatsApp line and priority phone routing to the technician on call, 24 hours a day.",
      btnWhatsapp: "Emergency WhatsApp",
      btnCall: "Emergency Call",
    },
    clientPortal: {
      eyebrow: "CLIENT PORTAL",
      loginTitle: "Sign in to your Mariot portal",
      loginSubtitle: "Access your equipment list, service history, and QR-tagged assets.",
      email: "Email",
      password: "Password",
      loginBtn: "Sign In",
      loginError: "Invalid credentials. Try the demo login or contact support.",
      useDemoCredentials: "Use demo credentials",
      notClient: "Not yet a client?",
      explorePlans: "Explore maintenance plans",
      logout: "Sign out",
      plan: "Active Plan",
      kpi1: "Total Assets",
      kpi2: "Operational",
      kpi3: "Service Due",
      kpi4: "Scheduled",
      tabAssets: "My Equipment",
      tabHistory: "Service History",
      tabSchedule: "Scheduled Visits",
      searchAssets: "Search by name, ID or brand...",
      statuses: {
        operational: "Operational",
        service_due: "Service Due",
        in_service: "In Service",
      },
      brand: "Brand",
      warranty: "Warranty Ends",
      lastService: "Last Service",
      viewQR: "QR Code",
      requestService: "Request Service",
      scheduled: "Scheduled",
      qrHint: "Scan to open the asset page with full history.",
      close: "Close",
    },
    sectorDetail: {
      deliversEyebrow: "WHAT WE DELIVER",
      deliversTitle: "Everything this sector needs — under one roof",
      caseEyebrow: "MINI CASE STUDY",
      projectsEyebrow: "SECTOR PROJECTS",
      projectsTitle: "Recent projects in this sector",
      ctaQuote: "Request a Quote",
      ctaBook: "Book a Consultation",
      restaurant: {
        h1: "Kitchens engineered for restaurants that never stop",
        subtitle: "Show kitchens, prep lines, cold rooms and stainless fabrication tuned to your menu and volume.",
        delivers: ["Cooking suites (ranges, ovens, grills, fryers)", "Refrigeration — chillers, freezers, walk-ins", "Prep lines, hot holding, salamanders", "Custom stainless tables, hoods and shelving", "Warewashing — dishwashers and pass-through", "HACCP-compliant workflow"],
        caseTitle: "Casual dining · 180 covers",
        caseSub: "Dubai Marina · turnkey in 6 weeks",
        caseHighlights: [
          { title: "Design & BOQ", text: "3D layout with dining, cooking, and pastry zones." },
          { title: "Supply", text: "Rational combi, Fimar ranges, Inofrigo refrigeration." },
          { title: "Fabrication", text: "12 custom stainless tables and 3 exhaust hoods." },
        ],
        caseStats: [{ value: "6 wks", label: "Total time" }, { value: "180", label: "Covers" }, { value: "3", label: "Zones" }],
        ctaTitle: "Building a restaurant kitchen?",
        ctaSubtitle: "Send us your layout and we'll come back with a tailored proposal within 24 hours.",
      },
      cafe: {
        h1: "Café kitchens that pour speed and consistency",
        subtitle: "Espresso platforms, brewing stations, compact prep and pastry — engineered for morning peak throughput.",
        delivers: ["Espresso machines (2, 3 or 4 group)", "Grinders, brewers, ice makers", "Under-counter refrigeration & pastry display", "Compact prep tables and wash stations", "Bar and back-bar stainless fabrication", "Compliant plumbing & electrical layout"],
        caseTitle: "Specialty café · 65 seats",
        caseSub: "Jumeirah · from concept to opening in 5 weeks",
        caseHighlights: [
          { title: "Design", text: "L-shaped bar layout maximizing barista flow." },
          { title: "Equipment", text: "La Marzocco Linea PB, Mahlkönig grinders." },
          { title: "Fabrication", text: "Custom stainless bar, sink station, display counter." },
        ],
        caseStats: [{ value: "5 wks", label: "Time" }, { value: "65", label: "Seats" }, { value: "3-grp", label: "Espresso" }],
        ctaTitle: "Opening a specialty café?",
        ctaSubtitle: "We help you pick the right coffee platform and design a bar that flows.",
      },
      hotel: {
        h1: "Multi-outlet hotel kitchens delivered on schedule",
        subtitle: "Main production, banquet, room service and restaurant outlets — engineered as one integrated project.",
        delivers: ["Main production with cook-chill", "Banquet and buffet lines", "In-room dining stations", "Multi-outlet restaurant kitchens", "Walk-in cold and freezer rooms", "Central warewashing with conveyor"],
        caseTitle: "5-star hotel · 400 keys",
        caseSub: "Abu Dhabi · 4 outlets · 14 weeks",
        caseHighlights: [
          { title: "Integrated design", text: "Master kitchen feeding 4 outlets and banquet halls." },
          { title: "Global brands", text: "Rational, Electrolux, Hobart, Inofrigo." },
          { title: "Commissioning", text: "Test cook, staff training, full documentation." },
        ],
        caseStats: [{ value: "14 wks", label: "Duration" }, { value: "4", label: "Outlets" }, { value: "1,200", label: "Meals/day" }],
        ctaTitle: "Planning a hotel kitchen?",
        ctaSubtitle: "Talk to our hospitality team about an integrated multi-outlet plan.",
      },
      resort: {
        h1: "Resort kitchens — beach bars to central production",
        subtitle: "From beach kitchens and pool bars to a central production hub feeding every outlet reliably.",
        delivers: ["Central production kitchen", "Pool and beach outdoor kitchens", "Buffet and banquet lines", "Cold rooms & freezer zones", "Custom stainless fabrication", "Weatherproof outdoor equipment"],
        caseTitle: "Luxury resort · 250 keys",
        caseSub: "Ras Al Khaimah · turnkey",
        caseHighlights: [
          { title: "Coverage", text: "Central kitchen + 3 outdoor stations + 2 restaurants." },
          { title: "Weatherproof", text: "Outdoor equipment rated for coastal humidity." },
          { title: "Custom", text: "Sun-shaded stainless prep stations." },
        ],
        caseStats: [{ value: "12 wks", label: "Duration" }, { value: "5", label: "Zones" }, { value: "250", label: "Keys served" }],
        ctaTitle: "Equipping a resort?",
        ctaSubtitle: "Book a discovery call to plan your resort kitchen across all outlets.",
      },
      villa_palace: {
        h1: "Private kitchens for villas, palaces & royal residences",
        subtitle: "Luxurious yet fully professional kitchens for private homes — main and secondary kitchens, majlis service pantries, outdoor grill stations and staff quarters kitchens.",
        delivers: [
          "Main show kitchen with premium built-in appliances",
          "Secondary chef's kitchen for full preparation",
          "Majlis & service pantry with hot/cold holding",
          "Outdoor grill / mandi / shawarma stations",
          "Staff quarters kitchen",
          "Custom stainless & wood-veneer millwork",
          "Absolute-discretion delivery & installation",
        ],
        caseTitle: "Private palace · Emirates Hills",
        caseSub: "Main + secondary + majlis + outdoor kitchens",
        caseHighlights: [
          { title: "Discretion", text: "NDA-covered project, delivered outside working hours." },
          { title: "Premium brands", text: "Miele, Sub-Zero, Wolf, La Cornue, La Marzocco." },
          { title: "Millwork", text: "Custom stainless + hardwood veneer integration." },
        ],
        caseStats: [
          { value: "4", label: "Kitchen zones" },
          { value: "10", label: "Weeks" },
          { value: "NDA", label: "Coverage" },
        ],
        ctaTitle: "Equipping a private residence?",
        ctaSubtitle: "We handle villa and palace projects with the discretion, quality and coordination they deserve.",
      },
      hospital: {
        h1: "HACCP-compliant hospital food service",
        subtitle: "Patient meal production, diet-line separation, and cook-chill workflow that pass every audit.",
        delivers: ["Diet-line cooking and portioning", "Cook-chill and blast chillers", "Patient meal trolleys (hot / cold)", "Staff cafeteria kitchen", "Stainless fabrication", "HACCP-compliant workflow"],
        caseTitle: "300-bed hospital · Sharjah",
        caseSub: "Patient meals + staff cafeteria",
        caseHighlights: [
          { title: "Compliance", text: "HACCP-zoned kitchen, negative-pressure diet room." },
          { title: "Equipment", text: "Rational iCombi, Inofrigo blast chillers." },
          { title: "Trolleys", text: "36 hot/cold meal distribution trolleys." },
        ],
        caseStats: [{ value: "300", label: "Beds" }, { value: "3", label: "Diet lines" }, { value: "900", label: "Meals/day" }],
        ctaTitle: "Equipping a healthcare kitchen?",
        ctaSubtitle: "Our HACCP-experienced team will guide you through a compliant design.",
      },
      bakery: {
        h1: "Bakery kitchens for artisan and volume production",
        subtitle: "Deck ovens, mixers, proofers and cooling systems for artisanal breads, pastries and viennoiserie.",
        delivers: ["Deck and rotary ovens", "Spiral and planetary mixers", "Retarder-proofers", "Sheeters, dividers, moulders", "Cooling racks and packaging areas", "Refrigeration for dough and cream"],
        caseTitle: "Artisan bakery · Central production",
        caseSub: "Dubai Industrial City · 800 kg dough/day",
        caseHighlights: [
          { title: "Ovens", text: "2 rotary + 1 deck oven for varied product lines." },
          { title: "Proofers", text: "Programmed proofing for overnight fermentation." },
          { title: "Cooling", text: "Automatic cooling conveyor for baguettes." },
        ],
        caseStats: [{ value: "800", label: "kg/day" }, { value: "3", label: "Ovens" }, { value: "24/7", label: "Operation" }],
        ctaTitle: "Launching a bakery?",
        ctaSubtitle: "We size the ovens, mixers and cold rooms to your daily production target.",
      },
      laundry: {
        h1: "Industrial laundries for hotels and healthcare",
        subtitle: "Continuous batch washers, tumble dryers, flatwork ironers and folding lines for volume laundry operations.",
        delivers: ["Barrier washers 30–150 kg", "Tumble dryers 30–120 kg", "Flatwork ironers 2–3.5 m", "Folding and stacking lines", "Steam boilers and softening plants", "Soiled and clean linen zoning"],
        caseTitle: "Hotel group central laundry",
        caseSub: "Dubai · 4 tonnes/day capacity",
        caseHighlights: [
          { title: "Wash line", text: "2 × 100 kg barrier washers + 3 dryers." },
          { title: "Ironers", text: "3 m flatwork ironer with folder-stacker." },
          { title: "Zoning", text: "Strict soiled/clean separation per HACCP." },
        ],
        caseStats: [{ value: "4 t", label: "Per day" }, { value: "3", label: "Ironer lines" }, { value: "24h", label: "Turnaround" }],
        ctaTitle: "Planning a commercial laundry?",
        ctaSubtitle: "Send us your daily volume and we'll size the full line.",
      },
      catering: {
        h1: "Catering & central kitchens for high-volume production",
        subtitle: "Cook, chill, package, transport — an end-to-end catering line for events and multi-site operations.",
        delivers: ["Batch cookers and tilting pans", "Blast chillers and freezers", "Vacuum packaging", "Hot & cold transport trolleys", "Cook-chill regeneration", "Central dishwashing"],
        caseTitle: "Corporate catering · 3,000 meals/day",
        caseSub: "Sharjah central kitchen",
        caseHighlights: [
          { title: "Cook line", text: "4 tilting kettles + 2 pressure cookers." },
          { title: "Chill", text: "6 blast chillers + walk-in cold storage." },
          { title: "Packaging", text: "Automatic vacuum & sealing line." },
        ],
        caseStats: [{ value: "3,000", label: "Meals/day" }, { value: "6", label: "Chillers" }, { value: "48h", label: "Shelf life" }],
        ctaTitle: "Scaling a catering operation?",
        ctaSubtitle: "Our team designs cook-chill kitchens engineered for volume.",
      },
      supermarket: {
        h1: "Supermarket refrigeration and food service",
        subtitle: "Refrigerated display cases, walk-in cold rooms, meat prep and in-store production kitchens.",
        delivers: ["Refrigerated display cases", "Multi-deck open chillers", "Walk-in cold and freezer rooms", "Meat and fish prep areas", "In-store bakery / deli counters", "Central refrigeration systems"],
        caseTitle: "Premium supermarket · 3,000 m²",
        caseSub: "Abu Dhabi · full fit-out",
        caseHighlights: [
          { title: "Display", text: "42 refrigerated cases across all categories." },
          { title: "Storage", text: "4 walk-in cold rooms + 2 freezers." },
          { title: "Prep", text: "Meat, fish, deli and bakery zones." },
        ],
        caseStats: [{ value: "3,000", label: "m²" }, { value: "42", label: "Cases" }, { value: "6", label: "Cold zones" }],
        ctaTitle: "Opening a supermarket?",
        ctaSubtitle: "We design your refrigeration and in-store food service end-to-end.",
      },
      cloud_kitchen: {
        h1: "Cloud kitchens engineered for delivery-only volume",
        subtitle: "Compact, standardized pods with shared cold storage and delivery-optimized layouts.",
        delivers: ["Standardized cooking pods", "Shared refrigeration", "Delivery packing station", "Ghost-kitchen exhaust systems", "Modular stainless fabrication", "Fast rollout across sites"],
        caseTitle: "Cloud kitchen operator · 8 pods",
        caseSub: "Al Quoz · 6 brands in one facility",
        caseHighlights: [
          { title: "Modular pods", text: "Standardized 20 m² cooking pods per brand." },
          { title: "Shared cold", text: "Central chill and freezer accessible to all pods." },
          { title: "Rollout", text: "Repeatable design for site 2 & 3 in 4 weeks each." },
        ],
        caseStats: [{ value: "8", label: "Pods" }, { value: "4 wks", label: "Per site" }, { value: "6", label: "Brands" }],
        ctaTitle: "Rolling out a cloud kitchen?",
        ctaSubtitle: "Ask us for a repeatable pod design to scale across sites.",
      },
      central_kitchen: {
        h1: "Central kitchens for multi-site operators",
        subtitle: "Cook-chill production, distribution logistics and portioning for restaurant chains and F&B groups.",
        delivers: ["Batch cooking suites", "Cook-chill process line", "Blast chillers & freezers", "Vacuum packing & sealing", "Cold storage and distribution", "Distribution trolleys"],
        caseTitle: "Restaurant chain central kitchen",
        caseSub: "Feeding 24 outlets across the UAE",
        caseHighlights: [
          { title: "Volume", text: "5 tonnes of prepared food per day." },
          { title: "Cook-chill", text: "48-hour cook-chill with vacuum sealing." },
          { title: "Distribution", text: "Refrigerated trucks feeding 24 outlets daily." },
        ],
        caseStats: [{ value: "24", label: "Outlets" }, { value: "5 t", label: "Per day" }, { value: "48h", label: "Shelf life" }],
        ctaTitle: "Building a central kitchen?",
        ctaSubtitle: "We plan production capacity, cold chain, and delivery logistics.",
      },
    },
    businessAccount: {
      eyebrow: "B2B TRADE ACCOUNT",
      title: "Open a Mariot Business Account",
      subtitle: "For groups, chains, and repeat buyers — get credit terms, a dedicated account manager, priority delivery and quarterly business reviews.",
      chip1: "Credit Terms Available",
      chip2: "Dedicated Manager",
      chip3: "Volume Pricing",
      card1Label: "Credit up to",
      card1Value: "Net 60",
      card2Label: "Volume Discount",
      card2Value: "up to 22%",
      benefitsEyebrow: "WHY OPEN AN ACCOUNT",
      benefitsTitle: "Benefits that grow with your business",
      benefits: [
        { title: "Flexible Credit Terms", text: "Net-15, Net-30, or Net-60 approved after account setup." },
        { title: "Dedicated Manager", text: "A single point of contact for orders, service, and after-sales." },
        { title: "Volume Pricing", text: "Tiered discounts based on annual commercial volume." },
        { title: "Priority Delivery", text: "Your orders jump the queue with same-week UAE-wide fulfilment." },
        { title: "Quarterly Reviews", text: "Business reviews to catch usage patterns and future needs." },
        { title: "Consolidated Invoicing", text: "Monthly consolidated invoicing across all outlets." },
      ],
      formEyebrow: "TRADE ACCOUNT APPLICATION",
      formTitle: "Open your account",
      formSubtitle: "Verified in 48 business hours. Documents can be sent later.",
      section1: "COMPANY DETAILS",
      section2: "PRIMARY CONTACT",
      section3: "COMMERCIAL PROFILE",
      companyName: "Legal Company Name",
      businessType: "Business Type",
      businessTypes: {
        restaurant_group: "Restaurant Group",
        hotel_chain: "Hotel Chain",
        catering: "Catering / Food Service",
        cloud_kitchen: "Cloud Kitchen Operator",
        supermarket: "Supermarket / Retail",
        bakery_chain: "Bakery Chain",
        other: "Other",
      },
      tradeLicense: "Trade License Number",
      vatNumber: "VAT / TRN Number",
      emirate: "Registered Emirate",
      contactName: "Contact Person",
      contactRole: "Role / Position",
      contactRolePlaceholder: "e.g. Procurement Manager",
      phone: "Phone / WhatsApp",
      email: "Business Email",
      monthlyVolume: "Expected Monthly Volume (AED)",
      monthlyVolumes: {
        under_20k: "Under 20,000 AED",
        "20k_100k": "20,000 – 100,000 AED",
        "100k_500k": "100,000 – 500,000 AED",
        over_500k: "Over 500,000 AED",
      },
      creditTerms: "Preferred Credit Terms",
      creditTermsOptions: {
        prepaid: "Prepaid",
        net_15: "Net 15 days",
        net_30: "Net 30 days",
        net_60: "Net 60 days",
      },
      authorizedSignatory: "Authorized Signatory (optional)",
      authorizedSignatoryHint: "Full name of authorized signatory",
      additionalNotes: "Additional Notes",
      submit: "Submit Application",
      formFooter: "Trade license and VAT certificate will be requested by email after submission.",
    },
    consultation: {
      eyebrow: "KITCHEN CONSULTATION",
      title: "Book a free kitchen consultation & site visit",
      subtitle: "60 minutes with a senior kitchen consultant. On-site visit, video call, or phone — whichever fits your project stage.",
      bullets: [
        "Free with no obligation",
        "Available across all 7 emirates",
        "Preliminary layout suggestions during the visit",
        "Written notes shared within 48 hours",
      ],
      demoLabel1: "Next available slot",
      demoValue1: "This week",
      demoLabel2: "Consultation confirmed",
      demoValue2: "Wed · 11:00 AM · Marina, Dubai",
      demoLabel3: "Response time",
      demoValue3: "< 4 hrs",
      steps: [
        { title: "You Book", text: "Pick a preferred date & time. Site visit, video call or phone — your choice." },
        { title: "We Confirm", text: "A consultant confirms within 4 hours and shares a project briefing." },
        { title: "You Meet & Plan", text: "We walk the space, discuss workflow, then follow up with a written report." },
      ],
      formEyebrow: "BOOK YOUR SLOT",
      formTitle: "Schedule your consultation",
      formSubtitle: "We'll confirm your slot within 4 working hours.",
      visitType: "Consultation Type",
      visitTypes: {
        site_visit: "Site Visit",
        video_call: "Video Call",
        phone_call: "Phone Call",
      },
      name: "Your Name",
      phone: "Phone / WhatsApp",
      email: "Email",
      projectStage: "Project Stage",
      projectStages: {
        idea: "Just an idea",
        concept: "Concept stage",
        design: "Design in progress",
        build: "Build / fit-out",
        operating: "Already operating",
      },
      emirate: "Emirate",
      address: "Site Address",
      addressHint: "Building, street, area",
      preferredDate: "Preferred Date",
      preferredTime: "Preferred Time",
      times: {
        morning: "Morning (9 AM – 12 PM)",
        afternoon: "Afternoon (12 PM – 4 PM)",
        evening: "Evening (4 PM – 8 PM)",
      },
      notes: "Anything we should prepare?",
      notesHint: "Menu concept, kitchen size, equipment already owned, etc.",
      submit: "Book Consultation",
      formFooter: "Booking is free. No obligation to proceed with any purchase.",
    },
    opening: {
      eyebrow: "RESTAURANT & CAFÉ OPENING",
      title: "From vision to opening day — end to end",
      subtitle: "Launch specialists guide you across licensing, design, equipment, staff training, and marketing so your opening runs on time and on budget.",
      chips: [
        "Concept-to-opening playbook",
        "Licensing coordination",
        "Equipment package deals",
        "Staff hire & train",
        "Soft-launch marketing",
      ],
      pillarsEyebrow: "END-TO-END SUPPORT",
      pillarsTitle: "Four pillars of a successful opening",
      pillars: [
        { title: "Design & Layout", text: "Kitchen and front-of-house layout engineered for your concept." },
        { title: "Equipment Packages", text: "Bundled equipment sourced from 40+ trusted brands." },
        { title: "Delivery & Install", text: "Coordinated logistics, install, testing, and handover." },
        { title: "Training & Launch", text: "Team training, pre-opening dry runs, and soft-launch support." },
      ],
      formEyebrow: "OPENING SUPPORT REQUEST",
      formTitle: "Tell us about your opening",
      formSubtitle: "A launch specialist will contact you within 24 hours.",
      section1: "YOUR CONCEPT",
      section2: "INVESTMENT & STAGE",
      section3: "CONTACT",
      conceptName: "Concept / Brand Name",
      conceptNameHint: "e.g. Blue Fig Kitchen",
      conceptType: "Concept Type",
      conceptTypes: {
        fine_dining: "Fine Dining",
        casual_dining: "Casual Dining",
        fast_casual: "Fast Casual",
        cafe: "Café / Coffee Shop",
        cloud_kitchen: "Cloud Kitchen",
        bakery: "Bakery / Pastry",
        food_truck: "Food Truck",
        other: "Other",
      },
      cuisine: "Cuisine / Style",
      cuisineHint: "e.g. Italian, Modern Levantine",
      seats: "Seats / Capacity",
      targetDate: "Target Opening Date",
      location: "Location",
      investment: "Investment Range (AED)",
      investmentRanges: {
        under_150k: "Under 150,000",
        "150k_500k": "150,000 – 500,000",
        "500k_1m": "500,000 – 1,000,000",
        "1m_3m": "1M – 3M",
        over_3m: "Over 3M",
      },
      currentStage: "Current Stage",
      stages: {
        idea: "Idea",
        concept: "Concept",
        design: "Design",
        fitout: "Fit-out",
        pre_opening: "Pre-opening",
      },
      needsLabel: "What do you need help with?",
      needs: {
        license: "Licensing",
        design: "Design",
        equipment: "Equipment",
        install: "Installation",
        training: "Staff Training",
        marketing: "Marketing",
      },
      contactName: "Your Name",
      phone: "Phone / WhatsApp",
      email: "Email",
      notes: "Anything else we should know?",
      notesHint: "Any partners, target audience, or challenges you'd like us to know about.",
      submit: "Request Opening Support",
      formFooter: "You'll receive an opening roadmap and rough investment breakdown within 24 hours.",
    },
    urgent: {
      eyebrow: "URGENT · SLA-BACKED RESPONSE",
      title: "Kitchen down? We move fast.",
      subtitle: "Same-day quotes, 48-hour delivery on stocked items, and priority engineering call-outs across the UAE.",
      whatsappNow: "WhatsApp Now",
      callNow: "Call Now",
      slaLabel: "OUR SLA",
      sla: [
        { label: "Response", value: "< 30 min" },
        { label: "Quote", value: "< 4 hrs" },
        { label: "Delivery (stocked)", value: "24–48 hrs" },
        { label: "Engineer call-out", value: "Same day" },
      ],
      problemsEyebrow: "WHAT WE HANDLE",
      problemsTitle: "The most common urgent situations we solve",
      problems: [
        { title: "Broken Equipment", text: "Repair, replace, or hire a temporary unit." },
        { title: "Fast Delivery", text: "Priority dispatch of stocked equipment UAE-wide." },
        { title: "Emergency Install", text: "Same-day install of critical replacement units." },
        { title: "Spare Parts", text: "Genuine parts pulled from our warehouse stock." },
      ],
      formEyebrow: "URGENT REQUEST",
      formTitle: "Log an urgent request",
      formSubtitle: "Fastest response via phone + WhatsApp. Photos help a lot.",
      urgency: "How urgent is it?",
      urgencies: {
        same_day: "Same day",
        next_48h: "Next 48 hrs",
        this_week: "This week",
      },
      problem: "Problem Category",
      problems_options: {
        downtime: "Equipment down / broken",
        delivery: "Need urgent delivery",
        installation: "Need urgent installation",
        replacement: "Replacement unit needed",
        spare_parts: "Spare parts",
        other: "Other",
      },
      equipmentType: "Equipment Type (if known)",
      equipmentTypeHint: "e.g. Combi oven, walk-in freezer",
      description: "What happened / what you need",
      descriptionHint: "Describe the problem in a few lines — we'll ask follow-ups on WhatsApp.",
      photo: "Photo of Equipment (recommended)",
      photoHint: "Upload a photo (PDF/JPG/PNG, max 10 MB)",
      contactSection: "CONTACT & LOCATION",
      contactName: "Your Name",
      businessName: "Business Name",
      phone: "Phone / WhatsApp",
      email: "Email",
      emirate: "Emirate",
      submit: "Send Urgent Request",
      formFooter: "Our on-call engineer will contact you within 30 minutes during working hours.",
    },
    about: {
      eyebrow: "ABOUT MARIOT",
      title: "About Mariot Kitchen Equipment",
      body: "Mariot Kitchen Equipment is a professional supplier of commercial kitchen equipment, refrigeration solutions, stainless steel fabrication, laundry equipment, and project support for restaurants, cafés, hotels, supermarkets, bakeries, catering companies, hospitals, resorts and commercial food service businesses.",
      visionTitle: "Our Vision",
      vision: "To become one of the leading commercial kitchen equipment and project solution providers in the UAE and GCC by delivering reliable products, professional service, and complete equipment solutions for every type of food service business.",
      missionTitle: "Our Mission",
      mission: "To help our clients build efficient, reliable, and professional kitchens by providing high-quality equipment, fast quotations, trusted brands, and complete project support from planning to supply.",
      whatWeDoTitle: "What We Do",
      whatWeDo: [
        "Supply of commercial kitchen equipment and cooking suites",
        "Commercial refrigeration — walk-in cold rooms, blast chillers, display cases",
        "Custom stainless steel fabrication (Grade 304 and 430)",
        "Laundry equipment for hotels, hospitals and industrial applications",
        "Complete turn-key project design, supply, installation and commissioning",
        "After-sales service, spare parts and maintenance contracts",
      ],
      sectorsTitle: "Target Sectors",
      strengthsTitle: "Our Strengths",
      strengths: [
        "Direct partnerships with top-tier global manufacturers",
        "Complete in-house engineering and design team",
        "UAE-based warehouse with immediate stock availability",
        "Multi-lingual sales and technical support",
      ],
    },
    projects: {
      eyebrow: "OUR PROJECTS", title: "Our Projects", subtitle: "Selected turn-key deliveries across the UAE.",
      filterAll: "All", empty: "No projects in this category yet.", viewDetails: "View project",
      location: "Location", emirate: "Emirate", completed: "Completed", client: "Client",
      scope: "Scope of Work", equipment: "Equipment Supplied", brandsUsed: "Brands Used",
      gallery: "Gallery", similar: "Request a Similar Project", backToAll: "Back to all projects",
    },
    brands: {
      eyebrow: "OUR GLOBAL BRANDS", title: "Our Global Brands",
      subtitle: "Authorized supply from the world's most respected manufacturers.",
      country: "Country", productCategories: "Product Categories", featuredProducts: "Featured Products",
      downloadCatalog: "Download Catalog", requestQuote: "Request Quotation", backToAll: "Back to all brands",
    },
    branches: {
      eyebrow: "OUR BRANCHES", title: "Our Branches",
      subtitle: "Serving customers across the UAE with dedicated local teams.",
      workingHours: "Working Hours", phone: "Phone", whatsapp: "WhatsApp",
      email: "Email", address: "Address", viewBranch: "View Branch",
      viewOnMap: "Open on Google Maps", backToAll: "Back to all branches",
    },
    blog: {
      eyebrow: "BLOG", title: "Insights & Guides",
      subtitle: "Expert advice on kitchen equipment, project planning and maintenance.",
      readMore: "Read article", by: "By", published: "Published",
      backToAll: "Back to all articles", relatedTitle: "Related articles", empty: "No articles yet.",
    },
    contact: {
      eyebrow: "GET IN TOUCH", title: "Contact Us",
      subtitle: "Reach out through your preferred channel — we typically respond within a few hours.",
      whatsappCta: "Chat on WhatsApp", callCta: "Call Us", emailCta: "Email Us",
    },
    quotation: {
      eyebrow: "REQUEST A QUOTATION", title: "Request a Free Quotation",
      subtitle: "Tell us about your project. Attach a BOQ or kitchen layout for an accurate quote.",
      name: "Full Name", phone: "Phone / WhatsApp", projectType: "Project Type",
      emirate: "Emirate", message: "Project Description", companyName: "Company Name",
      email: "Email Address", budget: "Approximate Budget (AED)", expectedDate: "Expected Start Date",
      website: "Company Website", preferredContact: "Preferred Contact Method",
      uploadLabel: "Upload BOQ or Kitchen Layout", uploadHint: "PDF, JPG or PNG — max 10MB",
      required: "required", optional: "optional",
      submit: "Submit Request", submitting: "Submitting...",
      success: "Thank you. Your request has been received. Our team will contact you shortly.",
      error: "Something went wrong. Please try again.",
      contact: { whatsapp: "WhatsApp", call: "Phone Call", email: "Email" },
      dates: { immediately: "Immediately", "1month": "Within 1 month", "3months": "Within 3 months", "6months": "Within 6 months", not_sure: "Not sure yet" },
      referenceLabel: "Interested in a similar project to:",
    },
    emirates: {
      dubai: "Dubai", abu_dhabi: "Abu Dhabi", sharjah: "Sharjah", ajman: "Ajman",
      ras_al_khaimah: "Ras Al Khaimah", fujairah: "Fujairah", umm_al_quwain: "Umm Al Quwain",
      al_ain: "Al Ain", other: "Other",
    },
    statuses: {
      new: "New", contacted: "Contacted", quotation_sent: "Quotation Sent",
      waiting_customer: "Waiting for Customer", approved: "Approved",
      rejected: "Rejected", closed: "Closed",
    },
    footer: {
      about: "Mariot Kitchen Equipment — professional supplier of commercial kitchen equipment, refrigeration, stainless steel fabrication and laundry solutions across the UAE and GCC.",
      quickLinks: "Quick Links", contact: "Contact", followUs: "Follow Us", rights: "All rights reserved.",
    },
    admin: {
      login: "Admin Login", email: "Email", password: "Password", signIn: "Sign in",
      dashboard: "Admin Dashboard", logout: "Logout",
      quotations: "Quotation Requests", projects: "Projects", brands: "Brands",
      branches: "Branches", blog: "Blog Posts",
      status: "Status", assignedStaff: "Assigned Staff", notes: "Notes",
      loginError: "Invalid email or password",
    },
    design: {
      eyebrow: "COMMERCIAL KITCHEN PLANNING & DESIGN",
      title: "From concept to a fully operational kitchen",
      subtitle: "3D design, precise engineering drawings, and world-class brands — our team is with you from the first sketch to the first plate.",
      cta1: "Start Your Consultation",
      cta2: "Talk to an Expert",
      badge1: "Free first consultation",
      badge2: "3D Design",
      badge3: "Install & Warranty",
      stats: [
        { value: "3D", label: "Live Design" },
        { value: "500+", label: "Delivered Projects" },
        { value: "20+", label: "Years of Experience" },
        { value: "40+", label: "Global Brands" },
      ],
      stagesEyebrow: "From paper to reality",
      stagesTitle: "We plan, design, execute",
      stagesSubtitle: "Precise engineering drawings, realistic 3D models, then a complete kitchen delivered.",
      stages: [
        { title: "Engineering Blueprint", text: "Compliant drawings and detailed equipment schedules." },
        { title: "3D Design", text: "Walk through your kitchen before a single piece is installed." },
        { title: "Complete Execution", text: "Supply, install and commission — ready for service." },
      ],
      viewer: {
        eyebrow: "INTERACTIVE 3D PREVIEW",
        title: "Explore a real kitchen — live 3D model",
        subtitle: "Free rotation around the layout, or walk through the equipment. An immersive engineering experience built on a real model.",
        tag1: "Interactive experience",
        tag2: "Real 3D model",
        hint: "Drag to rotate · Scroll to zoom · Tap the view buttons to switch angles",
      },
      sectorsEyebrow: "Sectoral Expertise",
      sectorsTitle: "Projects we plan and equip",
      sectorsSubtitle: "Specialized experience across every hospitality and food service segment.",
      processEyebrow: "How we work",
      processTitle: "Five steps to your ideal kitchen",
      process: [
        { title: "Discovery & Consultation", text: "We study your concept, menu, space and production capacity to define the optimal workflow." },
        { title: "3D Design", text: "2D and 3D layouts engineered for hygiene, workflow and code compliance." },
        { title: "Equipment Selection", text: "Curated choice from 40+ trusted global brands to fit your budget." },
        { title: "Supply & Installation", text: "Logistics, staging, MEP coordination and professional on-site installation." },
        { title: "Commissioning & Support", text: "Testing, staff handover, warranties, ongoing maintenance and spare parts." },
      ],
      whyEyebrow: "Why Mariot",
      whyTitle: "A standard competitors can't match",
      whySubtitle: "Design, authorized supply and professional installation — all under one roof, from the first sketch to the first plate.",
      whyItems: [
        { title: "One accountable partner", text: "A single team handles design, supply and install — no finger-pointing between vendors." },
        { title: "Original brands & warranties", text: "Authorized distribution with manufacturer warranties and certified after-sales service." },
        { title: "On time and on budget", text: "Transparent timelines and pricing locked from the planning phase." },
        { title: "Complete solutions", text: "From empty space to a fully operational, service-ready kitchen." },
      ],
      formEyebrow: "Start now",
      formTitle: "Request a consultation and plan your project",
      formSubtitle: "Tell us about your project and a planning expert will contact you within 24 business hours.",
      fields: {
        projectType: "Project type",
        name: "Full name",
        companyName: "Company / brand name",
        phone: "Phone number",
        email: "Email address",
        emirate: "City / Emirate",
        area: "Approximate area (m²)",
        budget: "Estimated budget",
        timeframe: "Timeframe",
        details: "Additional project details",
      },
      budgets: {
        under_50k: "Under 50,000 AED",
        "50k_150k": "50,000 – 150,000 AED",
        "150k_500k": "150,000 – 500,000 AED",
        "500k_plus": "Over 500,000 AED",
      },
      timeframes: {
        asap: "As soon as possible",
        "1_3_months": "1 – 3 months",
        "3_6_months": "3 – 6 months",
        planning: "Planning phase",
      },
      formSubmit: "Send Consultation Request",
      formNote: "Your data is only used to contact you about your project.",
      formSuccess: "Thank you. A planning expert will reach out within 24 business hours.",
      faqEyebrow: "FAQ",
      faqTitle: "Quick answers",
      faq: [
        { q: "Do you offer a free initial consultation?", a: "Yes — the first consultation and a preliminary layout proposal are completely free, with no obligation." },
        { q: "Which areas do you serve?", a: "We supply and install across all 7 emirates of the UAE, with dedicated branches supporting the wider region." },
        { q: "Do you work with our existing space and contractor?", a: "Absolutely. We coordinate with your architect, contractor and MEP team for seamless integration." },
        { q: "How long does a project usually take?", a: "Design takes 1–2 weeks; full supply and installation runs from 3 to 8 weeks depending on scope." },
      ],
      finalCtaTitle: "Ready to build your dream kitchen?",
      finalCtaSubtitle: "Free first consultation and a preliminary layout, no obligation.",
      finalCta: "Start Free Now",
    },
  },
  ar: {
    brand: "ماريوت لمعدات المطابخ",
    brandShort: "ماريوت",
    tagline: "معدات مطابخ احترافية وحلول مشاريع في الإمارات",
    nav: {
      home: "الرئيسية", about: "من نحن", projects: "مشاريعنا", brands: "الماركات",
      branches: "فروعنا", blog: "المدونة", contact: "تواصل", quote: "طلب عرض سعر", admin: "الإدارة",
      design: "صمم مشروعك",
      shop: "تسوق الآن",
      how: "كيف نعمل",
      sectors: "القطاعات",
      hub: "مركز الأعمال",
      fabrication: "التصنيع",
      maintenance: "الصيانة",
    },
    hero: {
      eyebrow: "متخصصون في المطابخ التجارية · الإمارات والخليج",
      title: "معدات مطابخ احترافية وحلول مشاريع في الإمارات",
      titleLead: "حلول مطابخ متكاملة",
      titleForConnector: "لـ",
      rotatingWords: ["المطاعم.", "الفنادق والمنتجعات.", "المقاهي والمخابز.", "الفلل والقصور."],
      subtitle: "نقوم بتوريد ودعم مشاريع المطابخ التجارية والتبريد والستانلس ستيل والغسيل وخدمات الطعام في الإمارات ودول الخليج.",
      cta1: "اطلب عرض سعر مجاني", cta2: "شاهد مشاريعنا", cta3: "تواصل عبر واتساب",
    },
    stats: { years: "سنوات من الخبرة", projects: "مشروع منجز", brands: "علامة عالمية", emirates: "إمارة نخدمها" },
    intro: {
      title: "حلول متكاملة للمطابخ التجارية",
      body: "على مدى عقدين من الزمن، ساعدنا في ماريوت المطاعم والفنادق والمستشفيات وشركات التموين والمنشآت الغذائية الصناعية في الإمارات على بناء مطابخ تعمل بكفاءة. من توريد قطعة واحدة إلى مشاريع متكاملة — نحن نسلّم.",
    },
    categoriesSection: { title: "قطاعات عملنا الرئيسية", subtitle: "حلول معدات متكاملة لكل قطاع في خدمات الطعام." },
    categories: {
      restaurant: "مطاعم", cafe: "مقاهي", hotel: "فنادق", resort: "منتجعات",
      villa_palace: "فلل وقصور",
      hospital: "مستشفيات", bakery: "مخابز", laundry: "مغاسل", catering: "خدمات تموين",
      supermarket: "سوبرماركت", cloud_kitchen: "مطابخ سحابية", central_kitchen: "مطابخ مركزية",
    },
    featured: { title: "مشاريع مختارة", subtitle: "لمحة عن أحدث مشاريعنا المتكاملة في الإمارات.", viewAll: "عرض جميع المشاريع" },
    brandsSection: { title: "ماركاتنا العالمية", subtitle: "نتعاون مع أوثق المصنّعين في العالم.", viewAll: "عرض جميع الماركات" },
    whyChoose: {
      title: "لماذا تختار ماريوت",
      subtitle: "الأسباب التي تجعل عملاءنا يثقون بنا في أهم مشاريعهم.",
      items: [
        { title: "أكثر من 20 سنة خبرة", text: "عقدان من توريد المطابخ التجارية في الإمارات والخليج." },
        { title: "ماركات عالمية موثوقة", text: "موزع معتمد لـ Rational و Fimar و Inofrigo و Asaki وغيرها." },
        { title: "حلول مشاريع متكاملة", text: "من التصميم وقائمة الكميات إلى التركيب والتشغيل وخدمات ما بعد البيع." },
        { title: "استجابة سريعة", text: "عروض أسعار في نفس اليوم ومديرو مشاريع مخصصون للحسابات الكبيرة." },
        { title: "تصنيع داخلي", text: "ورشة ستانلس ستيل خاصة لتصنيع الطاولات والشفاطات والأرفف والمزيد." },
        { title: "تغطية وطنية", text: "فروع وفرق خدمة في دبي وأبوظبي والإمارات الشمالية." },
      ],
    },
    ctaSection: {
      title: "جاهز لبناء مطبخك القادم؟",
      subtitle: "شارك تفاصيل مشروعك واستلم عرض سعر احترافي خلال 24 ساعة.",
      button: "اطلب عرض سعر مجاني",
    },
    shopSection: {
      eyebrow: "المتجر الإلكتروني",
      title: "تسوّق معدات المطابخ عبر الإنترنت",
      subtitle: "توصيل سريع لجميع أنحاء الإمارات. تصفح كتالوجنا الكامل من معدات المطابخ التجارية وقطع الغيار والإكسسوارات الجاهزة للطلب.",
      button: "تسوق الآن",
      badge1: "توصيل سريع",
      badge2: "علامات أصلية",
      badge3: "دفع آمن",
    },
    topBar: {
      delivery: "توصيل لجميع إمارات الدولة",
      catalogue: "تحميل الكتالوج",
      catalogueMsg: "السلام عليكم، أود طلب كتالوج منتجات ماريوت لمعدات المطابخ.",
      branches: "فروعنا",
    },
    heroChips: ["أكثر من 20 سنة خبرة", "جودة مضمونة", "توصيل سريع بالإمارات"],
    businessHub: {
      eyebrow: "مركز الأعمال — ماريوت",
      title: "حلول أعمال للمطاعم والمقاهي والفنادق والمطابخ التجارية",
      subtitle: "اطلب دعماً تجارياً وعروض أسعار للمشاريع ومساعدة في التوريد وإرشادات خبراء المطابخ التجارية من ماريوت.",
      items: [
        {
          title: "حساب تجاري / Trade Account",
          text: "افتح حساباً تجارياً واستمتع بدعم مستمر لأعمال B2B.",
          cta: "افتح حساباً",
          link: "/business-account",
        },
        {
          title: "استشارة مطبخ وزيارة موقع",
          text: "استشارة مجانية مع متخصص وزيارة معاينة للموقع.",
          cta: "احجز استشارة",
          link: "/consultation",
        },
        {
          title: "افتتاح مطعم أو كافيه",
          text: "دعم متكامل لإطلاق منشآت خدمات الطعام الجديدة.",
          cta: "ابدأ مشروعي",
          link: "/restaurant-opening",
        },
        {
          title: "طلب معدات عاجل",
          text: "توريد سريع عندما لا يحتمل مطبخك أي تأخير.",
          cta: "أرسل طلباً عاجلاً",
          link: "/urgent-request",
        },
      ],
    },
    packages: {
      eyebrow: "حلول مفتاح باليد",
      title: "الباقات والعروض",
      subtitle: "باقات معدات مخصصة للمشاريع الجديدة والمنشآت الناشئة.",
      cta: "اطلب الباقة",
      items: [
        { title: "افتتاح مطعم", text: "باقة بداية متكاملة للمطاعم الجديدة." },
        { title: "معدات كافيه", text: "كل ما تحتاجه لإطلاق مقهى ناجح." },
        { title: "حلول المخابز", text: "أفران وعجّانات وأساسيات المخابز." },
        { title: "بداية اقتصادية", text: "خيارات فعّالة من حيث التكلفة للمشاريع الجديدة." },
        { title: "مطبخ مخصص", text: "مشاريع مطابخ تجارية مخصّصة بالكامل." },
      ],
    },
    whyNumbered: {
      eyebrow: "لماذا ماريوت",
      title: "شريكك الموثوق للمطابخ",
      subtitle: "عقدان من الخبرة في معدات المطابخ التجارية في الإمارات والخليج.",
      items: [
        { title: "علامات عالمية", text: "معدات من أكثر من 40 مصنّعاً موثوقاً." },
        { title: "خبرة تجارية", text: "متخصصون في المطاعم والفنادق وخدمات التموين." },
        { title: "فريق خبراء", text: "مستشارون تقنيون يرشدونك في كل عملية شراء." },
        { title: "دعم ما بعد البيع", text: "صيانة وقطع غيار وخدمة تعتمد عليها." },
        { title: "توصيل وتركيب", text: "خدمات لوجستية احترافية في كل الإمارات." },
        { title: "تصنيع مخصص", text: "ورشة ستانلس ستيل داخلية بمقاساتك." },
        { title: "فروع متعددة", text: "حضور في كل الإمارات — دائماً قريبون منك." },
      ],
      numbersTitle: "بالأرقام",
      numbers: [
        { value: "500+", label: "مشروع منجز" },
        { value: "40+", label: "علامة عالمية" },
        { value: "300+", label: "عميل راضٍ" },
        { value: "7", label: "إمارات" },
      ],
      tagline: "نخدم أعرق المطاعم والفنادق والمنشآت الغذائية في الإمارات منذ 2004.",
    },
    brandsMarquee: {
      eyebrow: "تسوّق حسب العلامة",
      title: "علامات عالمية موثوقة",
      subtitle: "نشترك مع أبرز المصنّعين حول العالم.",
      viewAll: "عرض كل الماركات",
    },
    testimonials: {
      eyebrow: "آراء عملائنا",
      title: "ماذا يقول شركاؤنا",
      subtitle: "فخورون بثقة مئات الفنادق والمطاعم ومنشآت الضيافة في الإمارات والخليج.",
      trust1: "عميل نشط",
      trust2: "متوسط التقييم",
      trust3: "سنة في السوق",
      items: [
        {
          quote: "ماريوت شريكنا في معدات المطابخ لأكثر من 7 سنوات. جودة منتجات لا تُضاهى ودعم ما بعد بيع استثنائي — كل سلسلة مطاعمنا تعتمد عليهم.",
          name: "خالد المنصوري",
          role: "الشيف التنفيذي، ماريوت دبي",
          initials: "خ.م",
        },
        {
          quote: "جهّزنا مطبخنا التجاري بالكامل عن طريق ماريوت. التسليم في الموعد، والتركيب متقن، والمعدات تعمل بأداء يفوق التوقعات.",
          name: "فاطمة الراشدي",
          role: "مديرة العمليات، هيلتون أبوظبي",
          initials: "ف.ر",
        },
        {
          quote: "من الاستشارة حتى التشغيل، يجعل ماريوت تجهيز المطبخ الاحترافي سهلاً. خبرتهم في معدات المطابخ التجارية لا مثيل لها في الإمارات.",
          name: "أحمد قاسم",
          role: "مدير الأغذية والمشروبات، مجموعة روتانا",
          initials: "أ.ق",
        },
      ],
    },
    finalBigCta: {
      eyebrow: "جاهزون لتجهيز مطبخك؟",
      title: "بحاجة لمساعدة في تخطيط مطبخك التجاري؟",
      subtitle: "فريقنا جاهز للاستشارة وعرض الأسعار وتجهيز مشروعك من الألف إلى الياء — من أول رسم وحتى أول طبق.",
      btn1: "اطلب عرض سعر",
      btn2: "تواصل عبر واتساب",
      btn3: "فروعنا",
    },
    projectExtras: { photos: "صور" },
    clientsStrip: {
      title: "موثوق به من كبرى علامات الضيافة في الإمارات",
    },
    estimator: {
      eyebrow: "تقدير فوري",
      title: "قدّر ميزانية مشروع مطبخك",
      subtitle: "احصل على نطاق تقريبي بالدرهم لمطبخك التجاري خلال ثوانٍ — ثم اطلب عرض سعر دقيق من مهندسينا.",
      bullets: [
        "نطاقات مبنية على بيانات مشاريع حقيقية في الإمارات",
        "يشمل المعدات والتركيب والتصنيع الستانلس",
        "بدون أي التزام — للتخطيط فقط",
      ],
      widgetTitle: "حاسبة تكلفة المشروع",
      widgetHint: "اختر القطاع · الحجم · المستوى",
      sectorLabel: "القطاع",
      sizeLabel: "حجم المطبخ",
      levelLabel: "مستوى التجهيز",
      resultLabel: "نطاق الميزانية التقديري",
      forApprox: "لمساحة تقريبية",
      disclaimer: "تقدير فقط. السعر الفعلي يعتمد على الماركة والمخطط والأعمال الكهروميكانيكية وظروف الموقع.",
      cta: "احصل على عرض سعر دقيق",
    },
    thankYou: {
      eyebrow: "تم استلام طلبك",
      title: "شكراً لك — طلبك في أيدٍ أمينة",
      subtitle: "أحد متخصصي المشاريع لدينا سيراجع بياناتك ويتواصل معك قريباً بمقترح مخصص.",
      typedSubtitles: {
        business_account: "فريق الحسابات سيتحقق من مستنداتك التجارية ويؤكد حسابك خلال 48 ساعة عمل.",
        consultation: "فريق الاستشارات سيؤكد موعد الزيارة المفضّل ويجهّز ملف الاجتماع.",
        restaurant_opening: "متخصص الافتتاح سيتواصل معك لبناء جدول زمني ومحطات المشروع.",
        urgent: "تم إبلاغ مهندس الاستجابة العاجلة. توقّع اتصالاً حسب مدة الاستجابة التي اخترتها.",
      },
      timelineEyebrow: "الخطوات القادمة",
      timelineTitle: "رحلة مشروعك — من الطلب إلى التنفيذ",
      steps: [
        { time: "الآن", title: "تم استلام الطلب", text: "تم تسجيل بياناتك في مسار مشاريعنا وتعيين متخصص لك." },
        { time: "خلال 24 ساعة", title: "المراجعة الأولية", text: "نراجع متطلباتك والمساحة والجدول الزمني لإعداد الخطة المبدئية." },
        { time: "الأيام 1–3", title: "مكالمة استشارية", text: "يتواصل معك متخصص عبر القناة المفضلة للاتفاق على النطاق والخطوات التالية." },
        { time: "الأيام 3–7", title: "عرض سعر مفصل", text: "تستلم عرضاً احترافياً شاملاً يغطي المعدات والتركيب والضمان." },
      ],
      refTitle: "تحتاج لمشاركة تفاصيل إضافية؟",
      refText: "راسلنا عبر واتساب، أرفق المخططات أو قائمة الكميات، أو شارك صور المساحة — فريقنا جاهز.",
      actionsTitle: "أثناء انتظارك",
      actionsSubtitle: "استكشف أعمالنا أو تحدث مع فريقنا مباشرة لأي طلب عاجل.",
      btnWhatsapp: "تواصل عبر واتساب",
      btnProjects: "شاهد مشاريعنا",
      btnHome: "العودة للرئيسية",
    },
    stainlessFactory: {
      eyebrow: "مصنع تصنيع خاص · الإمارات",
      title: "لا نورّد فقط — بل نصنّع الستانلس ستيل حسب مقاسك",
      subtitle: "وحدات مخصصة نصنعها في مصنعنا داخل الإمارات وفق مخطط مطبخك بالتحديد. درجات 304 و 430، لحام دقيق وتشطيب بمعايير الضيافة.",
      badge1: "بمقاسك",
      badge2: "حرفيون داخليون",
      badge3: "درجة 304 و 430",
      badgeInPhoto: "مصنعنا",
      captionInPhoto: "كل درزة، كل زاوية — بأيدي فريقنا.",
      statLabel: "التسليم",
      statValue: "10–14 يوم",
      cta: "أرسل مخططاتك",
      items: {
        work_tables: "طاولات عمل",
        sinks: "أحواض ومغاسل",
        shelves: "رفوف",
        hoods: "شفاطات",
        trolleys: "عربات نقل",
        counters: "كاونترات وبوفيهات",
        cabinets: "خزائن",
        custom: "تصنيع مخصص",
      },
    },
    fabricationPage: {
      galleryEyebrow: "تصنيع حقيقي",
      galleryTitle: "ستانلس ستيل مخصص — لمطابخ حقيقية",
      gallerySubtitle: "كل وحدة تُرسم وتُلحم وتُصقل وتُسلَّم بأيدي فريقنا.",
      customBuild: "تصنيع مخصص",
      specs: [
        { label: "المادة", title: "AISI 304 و 430", text: "ستانلس درجة غذائية، مقاوم للتآكل، بمعايير الضيافة." },
        { label: "دقة", title: "لحام TIG", text: "درزات نظيفة تجتاز تدقيق HACCP بدون فجوات." },
        { label: "مدة التسليم", title: "10–14 يوماً", text: "وحدات مقاس-حسب-الطلب جاهزة خلال أسبوعين من الاعتماد." },
      ],
    },
    globalReach: {
      eyebrow: "تصدير عالمي · نخدم دول الخليج",
      title: "مقرنا الإمارات · نورّد لكل العالم",
      subtitle: "نورّد معدات المطابخ التجارية لجميع دول الخليج الست ونصدّر إلى أسواق مختارة في الشرق الأوسط وأفريقيا وآسيا — بلوجستيات مضبوطة على مواعيد الضيافة.",
      logistics1: "شحن بري",
      logistics2: "شحن بحري",
      logistics3: "شحن جوي",
      ctaQuote: "اطلب عرض تصدير",
      ctaContact: "تواصل مع فريق التصدير",
      gccEyebrow: "أسواق الخليج",
      gccTitle: "خدمة مباشرة لكل دول الخليج الست",
      beyondEyebrow: "خارج الخليج",
      beyondTitle: "تصدير لأسواق دولية مختارة",
      homeBase: "المقر الرئيسي",
      activeMarket: "سوق نشط",
      morePlus: "المزيد عند الطلب",
      stat1: "دولة نخدمها",
      stat2: "مشروع تصدير",
      stat3: "دعم على مدار",
    },
    maintenancePromo: {
      eyebrow: "صيانة احترافية · الإمارات",
      title: "حافظ على تشغيل مطبخك — قلّل التوقف حتى 75%",
      subtitle: "فريق صيانة داخلي مخصص، خطط صيانة وقائية، مستودع قطع غيار، واستدعاءات طوارئ 24/7 للفنادق والمطاعم ومشغلي المنافذ المتعددة.",
      features: [
        "زيارات صيانة وقائية",
        "استجابة طوارئ في نفس اليوم",
        "مستودع قطع غيار أصلية",
        "تتبع معدات بأكواد QR",
        "فنيون معتمدون لكل ماركة",
        "تقارير أداء شهرية",
      ],
      cta: "استكشف باقات الصيانة",
      viewPlans: "شاهد الأسعار",
      stat1: "انخفاض في توقف المعدات",
      stat2: "زيادة في عمر المعدات",
      stat3: "توفير متوسط على الصيانة السنوية",
    },
    maintenance: {
      eyebrow: "خطط الصيانة والخدمة",
      title: "صيانة احترافية تُبقي مطبخك يعمل",
      subtitle: "فنيون داخليون، خطط صيانة وقائية، قطع غيار أصلية، وبوابة ذكية لتتبع كل مكالمة خدمة وكل معدة في الوقت الحقيقي.",
      viewPlans: "شاهد الباقات والأسعار",
      requestQuote: "اطلب تدقيقاً مجانياً للموقع",
      stats: [
        { value: "75%", label: "التوقف", desc: "انخفاض في توقف المعدات عبر أسطول عملائنا." },
        { value: "50%", label: "العمر", desc: "زيادة عمر المعدات من خلال العناية الوقائية." },
        { value: "30%", label: "توفير التكلفة", desc: "توفير متوسط على الصيانة السنوية مقارنة بمشغلي الطوارئ فقط." },
      ],
      featuresEyebrow: "المنصة والعملية",
      featuresTitle: "كل ما تحتاجه لإبقاء كل معدة تعمل بأفضل أداء",
      featuresSubtitle: "عملية صيانة حديثة تجمع الفنيين المعتمدين ببوابة ذكية.",
      features: [
        { title: "جدولة ذكية", text: "احجز وأعد جدولة وتتبع كل زيارة خدمة أونلاين.", bullets: ["تقويم زيارات وقائية", "استدعاءات طارئة", "تحديثات حالة فورية"] },
        { title: "أكواد QR للمعدات", text: "كل وحدة تحصل على كود QR بكامل تاريخها بمسح واحد.", bullets: ["تاريخ الخدمة", "الكتيبات والضمان", "بحث قطع الغيار"] },
        { title: "تقارير وتحليلات", text: "لوحات شهرية لوقت التشغيل والإنفاق وأداء الأصول.", bullets: ["اتجاهات التوقف", "التكلفة لكل أصل", "تقارير المطابقة"] },
        { title: "شات مباشر مع الفنيين", text: "تحدث مع مهندسينا مباشرة للنصائح والتحديثات.", bullets: ["شات داخل البوابة", "رفع صور وفيديو", "حلول في نفس اليوم"] },
        { title: "صيانة وقائية", text: "عناية مجدولة تمنع العطل قبل أن يُعطّل مطبخك.", bullets: ["جداول الشركة المصنعة", "تنظيف عميق", "فحوصات معايرة"] },
        { title: "استجابة سريعة", text: "استجابة طوارئ 24/7 بمعدلات SLA مضمونة.", bullets: ["استجابة هاتفية 30 دقيقة", "زيارة موقع في نفس اليوم", "خيارات معدات إعارة"] },
      ],
      plansEyebrow: "باقات الصيانة",
      plansTitle: "اختر الباقة التي تناسب عملك",
      plansSubtitle: "باقات شفافة متدرجة — رقّي أو وسّع مع نمو عملياتك.",
      mostPopular: "الأكثر شعبية",
      selectPlan: "اختر هذه الباقة",
      plans: [
        {
          key: "essential",
          eyebrow: "أساسي",
          name: "العناية الأساسية",
          tagline: "صيانة وقائية أساسية للعمليات الصغيرة.",
          priceFrom: "990 درهم",
          priceUnit: "/ شهرياً",
          priceNote: "لحتى 10 وحدات معدات",
          features: [
            "زيارتان وقائيتان سنوياً",
            "استجابة في ساعات العمل",
            "استدعاء طوارئ خلال 48 ساعة",
            "تقرير ربع سنوي أساسي",
            "خصم 10% على قطع الغيار",
          ],
        },
        {
          key: "professional",
          eyebrow: "احترافي",
          name: "الخطة الاحترافية",
          tagline: "عناية شاملة للمطاعم والمقاهي.",
          priceFrom: "2,490 درهم",
          priceUnit: "/ شهرياً",
          priceNote: "لحتى 30 وحدة معدات",
          featured: true,
          features: [
            "4 زيارات وقائية سنوياً",
            "استدعاء طوارئ في نفس اليوم",
            "أكواد QR ووصول للبوابة",
            "تقرير أداء شهري",
            "خصم 15% على قطع الغيار",
            "شات مباشر مع الفنيين",
          ],
        },
        {
          key: "premium",
          eyebrow: "بريميوم",
          name: "أسطول بريميوم",
          tagline: "خدمة شاملة بـSLA للفنادق والسلاسل.",
          priceFrom: "6,900 درهم",
          priceUnit: "/ شهرياً",
          priceNote: "لـ30+ وحدة أو أساطيل متعددة المنافذ",
          features: [
            "زيارات وقائية شهرية",
            "SLA طوارئ 4 ساعات",
            "بوابة ذكية كاملة + تحليلات",
            "فني حساب مخصص",
            "خصم 20% على قطع الغيار",
            "معدات إعارة أثناء التوقف",
            "جلسات تدريب للطاقم",
          ],
        },
      ],
      trust: [
        { value: "24/7", label: "دعم الطوارئ" },
        { value: "500+", label: "عميل مخدوم" },
        { value: "12", label: "فني معتمد" },
        { value: "48س", label: "SLA قطع الغيار" },
      ],
      formEyebrow: "طلب باقة صيانة",
      formTitle: "احصل على عرض صيانة مخصص",
      formSubtitle: "أخبرنا عن أسطول معداتك. سنرد خلال 24 ساعة عمل.",
      selectedPlan: "الباقة المفضلة",
      company: "اسم الشركة",
      contactName: "المسؤول عن التواصل",
      phone: "الهاتف / واتساب",
      email: "البريد الإلكتروني",
      equipmentCount: "عدد المعدات (تقريبي)",
      outlets: "عدد المنافذ",
      emirate: "الإمارة",
      notes: "ملاحظات إضافية",
      notesHint: "أنواع المعدات، الوضع الحالي للصيانة، درجة الاستعجال، إلخ.",
      submit: "اطلب عرض السعر",
      formFooter: "يشمل تدقيقاً مجانياً في الموقع للعمليات المؤهلة.",
      downloadContract: "تحميل نموذج العقد",
      clientPortal: "بوابة العملاء",
    },
    maintenanceReviews: {
      eyebrow: "عملاء صيانة حقيقيون",
      title: "أعرق مطابخ الإمارات تثق بنا",
      subtitle: "قادة الأغذية والمشروبات يعتمدون على ماريوت لإبقاء معداتهم تعمل — إليك آراءهم.",
      items: [
        {
          quote: "منذ تحوّلنا لخطة ماريوت الاحترافية، انخفض التوقف غير المخطط بأكثر من النصف. بوابة العملاء تجعل متابعة كل زيارة خدمة سهلة جداً.",
          name: "رانيا الكمال",
          role: "مديرة الأغذية والمشروبات، مجموعة Blue Fig",
          initials: "ر.ك",
          metricLabel: "انخفاض التوقف",
          metricValue: "-62%",
        },
        {
          quote: "SLA الاستجابة 4 ساعات أنقذنا في ذروتي خدمة. فنيوهم معتمدون لماركات ما كنا نعرف أنهم يغطونها.",
          name: "فيصل الهاشمي",
          role: "مدير العمليات، Emerald Hospitality",
          initials: "ف.ه",
          metricLabel: "استجابة SLA",
          metricValue: "3س 12د",
        },
        {
          quote: "كل معدة عندنا صار لها كود QR بكامل تاريخها. تدريب شيف جديد على المعدات كان يأخذ أياماً — الآن مسح واحد.",
          name: "يارا نصار",
          role: "الشيف التنفيذية، Marina Beach Resort",
          initials: "ي.ن",
          metricLabel: "تدريب أسرع بـ",
          metricValue: "5x",
        },
        {
          quote: "رسوم صيانة شهرية ثابتة استبدلت فواتير الإصلاح العشوائية. وفّرنا حوالي 30% سنوياً وحصلنا على خدمة أفضل.",
          name: "مروان حسن",
          role: "المدير المالي، Levantine Kitchens Group",
          initials: "م.ح",
          metricLabel: "توفير سنوي",
          metricValue: "-28%",
        },
      ],
    },
    emergencyLine: {
      compactLabel: "خط الطوارئ",
      eyebrow: "صيانة طارئة 24/7",
      title: "المطبخ متوقف؟ اتصل بمهندس الاستدعاء الآن.",
      subtitle: "لعملاء خطط الصيانة النشطة — خط واتساب مباشر ومكالمة أولوية للفني المناوب على مدار 24 ساعة.",
      btnWhatsapp: "واتساب طارئ",
      btnCall: "اتصال طارئ",
    },
    clientPortal: {
      eyebrow: "بوابة العملاء",
      loginTitle: "سجّل الدخول إلى بوابة ماريوت",
      loginSubtitle: "اطّلع على قائمة معداتك وسجل الخدمة والأصول المُرمّزة QR.",
      email: "البريد الإلكتروني",
      password: "كلمة المرور",
      loginBtn: "تسجيل الدخول",
      loginError: "بيانات دخول غير صحيحة. جرّب الدخول التجريبي أو تواصل مع الدعم.",
      useDemoCredentials: "استخدم بيانات تجريبية",
      notClient: "لست عميلاً بعد؟",
      explorePlans: "استكشف خطط الصيانة",
      logout: "خروج",
      plan: "الخطة النشطة",
      kpi1: "إجمالي المعدات",
      kpi2: "تعمل",
      kpi3: "تحتاج صيانة",
      kpi4: "مجدولة",
      tabAssets: "معداتي",
      tabHistory: "سجل الخدمة",
      tabSchedule: "الزيارات المجدولة",
      searchAssets: "ابحث بالاسم أو الرمز أو الماركة...",
      statuses: {
        operational: "تعمل",
        service_due: "تحتاج صيانة",
        in_service: "قيد الصيانة",
      },
      brand: "الماركة",
      warranty: "نهاية الضمان",
      lastService: "آخر خدمة",
      viewQR: "كود QR",
      requestService: "اطلب خدمة",
      scheduled: "مجدولة",
      qrHint: "امسح الكود لفتح صفحة الأصل بالتاريخ الكامل.",
      close: "إغلاق",
    },
    sectorDetail: {
      deliversEyebrow: "ماذا نقدم",
      deliversTitle: "كل ما يحتاجه هذا القطاع — تحت سقف واحد",
      caseEyebrow: "دراسة حالة مصغرة",
      projectsEyebrow: "مشاريع القطاع",
      projectsTitle: "أعمال حديثة في هذا القطاع",
      ctaQuote: "اطلب عرض سعر",
      ctaBook: "احجز استشارة",
      restaurant: {
        h1: "مطابخ مصممة لمطاعم لا تتوقف",
        subtitle: "مطابخ عرض وخطوط تحضير وغرف تبريد وتصنيع ستانلس مضبوط على المنيو والحجم.",
        delivers: ["خطوط طهي (شوايات، أفران، فرايرز)", "تبريد — مبردات ومجمدات وووك-إن", "خطوط تحضير وسخانات وسلامندر", "طاولات وشفاطات ستانلس مخصصة", "غسيل صحون — تحت الكاونتر وباس-ثرو", "انسيابية مطابقة لـHACCP"],
        caseTitle: "مطعم كاجوال · 180 مقعد",
        caseSub: "مارينا دبي · تسليم متكامل خلال 6 أسابيع",
        caseHighlights: [
          { title: "التصميم", text: "مخطط ثلاثي الأبعاد بمناطق طعام وطهي ومعجنات." },
          { title: "التوريد", text: "Rational Combi، Fimar، Inofrigo." },
          { title: "التصنيع", text: "12 طاولة ستانلس و 3 شفاطات." },
        ],
        caseStats: [{ value: "6 أسابيع", label: "المدة" }, { value: "180", label: "مقعد" }, { value: "3", label: "مناطق" }],
        ctaTitle: "تبني مطبخ مطعم؟",
        ctaSubtitle: "أرسل لنا المخطط وسنعود بمقترح مخصص خلال 24 ساعة.",
      },
      cafe: {
        h1: "مطابخ مقاهي تصب سرعة وثبات",
        subtitle: "منصات إسبريسو ومحطات تخمير وتحضير مدمج ومعجنات — مصممة لذروة الصباح.",
        delivers: ["ماكينات إسبريسو (2/3/4 مجموعة)", "مطاحن وبريور وثلج", "تبريد تحت كاونتر وعرض معجنات", "طاولات تحضير مدمجة ومغاسل", "بار وباك-بار ستانلس مخصص", "سباكة وكهرباء مطابقة"],
        caseTitle: "كافيه قهوة مختصة · 65 مقعد",
        caseSub: "جميرا · من الفكرة للافتتاح خلال 5 أسابيع",
        caseHighlights: [
          { title: "التصميم", text: "بار على شكل L يحقق أفضل انسيابية." },
          { title: "المعدات", text: "La Marzocco Linea PB، مطاحن Mahlkönig." },
          { title: "التصنيع", text: "بار ومغسلة وكاونتر عرض مخصصة." },
        ],
        caseStats: [{ value: "5 أسابيع", label: "المدة" }, { value: "65", label: "مقعد" }, { value: "3-مج", label: "إسبريسو" }],
        ctaTitle: "تفتح كافيه مختصة؟",
        ctaSubtitle: "نساعدك باختيار منصة القهوة وتصميم بار انسيابي.",
      },
      hotel: {
        h1: "مطابخ فنادق متعددة المنافذ تُسلَّم في وقتها",
        subtitle: "إنتاج رئيسي وحفلات وخدمة غرف ومطاعم منافذ — كمشروع مدمج واحد.",
        delivers: ["إنتاج رئيسي مع طهي-تبريد", "خطوط حفلات وبوفيه", "محطات خدمة الغرف", "مطابخ منافذ متعددة", "غرف تبريد وتجميد ووك-إن", "غسيل صحون مركزي بحزام"],
        caseTitle: "فندق 5 نجوم · 400 مفتاح",
        caseSub: "أبوظبي · 4 منافذ · 14 أسبوعاً",
        caseHighlights: [
          { title: "تصميم مدمج", text: "مطبخ رئيسي يغذي 4 منافذ وقاعات حفلات." },
          { title: "علامات عالمية", text: "Rational، Electrolux، Hobart، Inofrigo." },
          { title: "التشغيل", text: "طهي اختباري وتدريب طاقم وتوثيق كامل." },
        ],
        caseStats: [{ value: "14 أسبوعاً", label: "المدة" }, { value: "4", label: "منافذ" }, { value: "1,200", label: "وجبة/يوم" }],
        ctaTitle: "تخطط لمطبخ فندق؟",
        ctaSubtitle: "تحدث مع فريق الضيافة لخطة مدمجة متعددة المنافذ.",
      },
      resort: {
        h1: "مطابخ منتجعات — من بارات الشاطئ للإنتاج المركزي",
        subtitle: "من مطابخ الشاطئ وبارات المسبح إلى إنتاج مركزي يغذي كل المنافذ.",
        delivers: ["مطبخ إنتاج مركزي", "مطابخ خارجية للمسبح والشاطئ", "خطوط بوفيه وحفلات", "غرف تبريد وتجميد", "تصنيع ستانلس مخصص", "معدات خارجية مقاومة للطقس"],
        caseTitle: "منتجع فاخر · 250 مفتاح",
        caseSub: "رأس الخيمة · تسليم متكامل",
        caseHighlights: [
          { title: "التغطية", text: "مطبخ مركزي + 3 محطات خارجية + مطعمان." },
          { title: "مقاوم للطقس", text: "معدات خارجية مصنفة لرطوبة الساحل." },
          { title: "مخصص", text: "محطات تحضير ستانلس بمظلات." },
        ],
        caseStats: [{ value: "12 أسبوعاً", label: "المدة" }, { value: "5", label: "مناطق" }, { value: "250", label: "مفتاح" }],
        ctaTitle: "تجهّز منتجعاً؟",
        ctaSubtitle: "احجز مكالمة استكشاف لتخطيط مطبخ منتجعك بكل منافذه.",
      },
      villa_palace: {
        h1: "مطابخ خاصة للفلل والقصور والإقامات الملكية",
        subtitle: "مطابخ فاخرة واحترافية بالكامل للمنازل الخاصة — مطبخ رئيسي وثانوي، بانتري مجلس، محطات شواء خارجية، ومطبخ الخدم.",
        delivers: [
          "مطبخ عرض رئيسي بأجهزة مدمجة فاخرة",
          "مطبخ ثاني للشيف للتحضير الكامل",
          "بانتري مجلس مع محطات حفظ ساخن/بارد",
          "محطات شواء خارجية / مندي / شاورما",
          "مطبخ سكن الخدم",
          "أعمال ستانلس وخشب مخصصة",
          "تسليم وتركيب بأقصى درجات الخصوصية",
        ],
        caseTitle: "قصر خاص · تلال الإمارات",
        caseSub: "رئيسي + ثاني + مجلس + خارجي",
        caseHighlights: [
          { title: "الخصوصية", text: "المشروع بغطاء NDA وتنفيذ خارج ساعات العمل." },
          { title: "علامات فاخرة", text: "Miele، Sub-Zero، Wolf، La Cornue، La Marzocco." },
          { title: "أعمال خشبية", text: "دمج ستانلس ستيل مع قشور خشب صلب مخصصة." },
        ],
        caseStats: [
          { value: "4", label: "مناطق مطبخ" },
          { value: "10", label: "أسابيع" },
          { value: "NDA", label: "تغطية" },
        ],
        ctaTitle: "تجهّز منزلاً خاصاً؟",
        ctaSubtitle: "نتعامل مع مشاريع الفلل والقصور بالخصوصية والجودة والتنسيق الذي تستحقه.",
      },
      hospital: {
        h1: "خدمة طعام مستشفيات مطابقة لـHACCP",
        subtitle: "إنتاج وجبات المرضى وفصل خطوط الأنظمة وطهي-تبريد يجتاز كل تدقيق.",
        delivers: ["طهي وتوزين خطوط الأنظمة", "طهي-تبريد ومبردات صدمة", "عربات وجبات مرضى (ساخن/بارد)", "مطبخ كافيتيريا الطاقم", "تصنيع ستانلس", "انسيابية مطابقة لـHACCP"],
        caseTitle: "مستشفى 300 سرير · الشارقة",
        caseSub: "وجبات مرضى + كافيتيريا طاقم",
        caseHighlights: [
          { title: "المطابقة", text: "مطبخ مقسم HACCP وغرفة أنظمة بضغط سالب." },
          { title: "المعدات", text: "Rational iCombi، مبردات Inofrigo." },
          { title: "العربات", text: "36 عربة توزيع وجبات ساخنة/باردة." },
        ],
        caseStats: [{ value: "300", label: "سرير" }, { value: "3", label: "خطوط أنظمة" }, { value: "900", label: "وجبة/يوم" }],
        ctaTitle: "تجهّز مطبخ رعاية صحية؟",
        ctaSubtitle: "فريقنا الخبير بـHACCP يرشدك لتصميم مطابق.",
      },
      bakery: {
        h1: "مطابخ مخابز للإنتاج الحرفي والحجمي",
        subtitle: "أفران طبقات وعجانات ومخمرات وأنظمة تبريد للخبز والمعجنات.",
        delivers: ["أفران طبقات ودوارة", "عجانات لولبية وكوكبية", "مخمرات-مبردات", "قوالب ومقسمات ومشكلات", "رفوف تبريد ومناطق تعبئة", "تبريد للعجين والكريم"],
        caseTitle: "مخبز حرفي · إنتاج مركزي",
        caseSub: "دبي الصناعية · 800 كغ عجين/يوم",
        caseHighlights: [
          { title: "الأفران", text: "دواران + طبقات واحد لتنوع المنتجات." },
          { title: "المخمرات", text: "تخمير مبرمج لليلة كاملة." },
          { title: "التبريد", text: "حزام تبريد آلي للباجيت." },
        ],
        caseStats: [{ value: "800", label: "كغ/يوم" }, { value: "3", label: "أفران" }, { value: "24/7", label: "تشغيل" }],
        ctaTitle: "تطلق مخبزاً؟",
        ctaSubtitle: "نحدد الأفران والعجانات والغرف حسب هدف إنتاجك اليومي.",
      },
      laundry: {
        h1: "مغاسل صناعية للفنادق والرعاية الصحية",
        subtitle: "غسالات وحاويات ومكاوي مسطحة وخطوط طي للعمليات الحجمية.",
        delivers: ["غسالات حاجزة 30–150 كغ", "مجففات 30–120 كغ", "مكاوي مسطحة 2–3.5 م", "خطوط طي وترتيب", "غلايات بخار ومحطات تنعيم", "فصل مناطق النظيف/المتسخ"],
        caseTitle: "مغسلة مركزية لمجموعة فنادق",
        caseSub: "دبي · 4 طن/يوم",
        caseHighlights: [
          { title: "خط الغسيل", text: "2 × 100 كغ غسالات حاجزة + 3 مجففات." },
          { title: "المكاوي", text: "مكواة 3 م مع طاوي." },
          { title: "الفصل", text: "فصل صارم متسخ/نظيف حسب HACCP." },
        ],
        caseStats: [{ value: "4 طن", label: "يومياً" }, { value: "3", label: "خطوط كي" }, { value: "24س", label: "دوران" }],
        ctaTitle: "تخطط لمغسلة تجارية؟",
        ctaSubtitle: "أرسل حجمك اليومي وسنحدد الخط كاملاً.",
      },
      catering: {
        h1: "تموين ومطابخ مركزية للإنتاج الحجمي",
        subtitle: "طهي، تبريد، تعبئة، نقل — خط تموين متكامل للفعاليات والمواقع المتعددة.",
        delivers: ["مقالي دفعية ومقالي مائلة", "مبردات صدمة ومجمدات", "تعبئة فراغية", "عربات نقل ساخن وبارد", "طهي-تبريد وتجديد", "غسيل صحون مركزي"],
        caseTitle: "تموين شركات · 3,000 وجبة/يوم",
        caseSub: "مطبخ مركزي في الشارقة",
        caseHighlights: [
          { title: "خط الطهي", text: "4 غلايات مائلة + 2 قدر ضغط." },
          { title: "التبريد", text: "6 مبردات صدمة + مخزن ووك-إن." },
          { title: "التعبئة", text: "خط تعبئة وتغليف فراغي آلي." },
        ],
        caseStats: [{ value: "3,000", label: "وجبة/يوم" }, { value: "6", label: "مبردات" }, { value: "48س", label: "صلاحية" }],
        ctaTitle: "توسّع عملية تموين؟",
        ctaSubtitle: "فريقنا يصمم مطابخ طهي-تبريد للحجم الكبير.",
      },
      supermarket: {
        h1: "تبريد سوبرماركت وخدمات طعام",
        subtitle: "منضدات عرض مبردة وغرف ووك-إن وتجهيز لحوم ومطابخ إنتاج داخل المتجر.",
        delivers: ["منضدات عرض مبردة", "مبردات مفتوحة متعددة الطبقات", "غرف تبريد وتجميد", "مناطق تجهيز لحوم وأسماك", "مخبز/ديلي داخل المتجر", "أنظمة تبريد مركزية"],
        caseTitle: "سوبرماركت راقٍ · 3,000 م²",
        caseSub: "أبوظبي · تجهيز متكامل",
        caseHighlights: [
          { title: "العرض", text: "42 منضدة مبردة لكل الأقسام." },
          { title: "التخزين", text: "4 غرف تبريد + 2 تجميد." },
          { title: "التجهيز", text: "لحوم، أسماك، ديلي، مخبز." },
        ],
        caseStats: [{ value: "3,000", label: "م²" }, { value: "42", label: "منضدة" }, { value: "6", label: "مناطق باردة" }],
        ctaTitle: "تفتح سوبرماركت؟",
        ctaSubtitle: "نصمم لك التبريد وخدمة الطعام داخل المتجر بالكامل.",
      },
      cloud_kitchen: {
        h1: "مطابخ سحابية مصممة لحجم التوصيل فقط",
        subtitle: "وحدات مدمجة موحدة مع تخزين تبريد مشترك وتخطيط مُحسَّن للتوصيل.",
        delivers: ["وحدات طهي موحدة", "تبريد مشترك", "محطة تعبئة توصيل", "أنظمة شفط للمطابخ الشبحية", "تصنيع ستانلس معياري", "توسّع سريع للمواقع"],
        caseTitle: "مشغل مطبخ سحابي · 8 وحدات",
        caseSub: "القوز · 6 علامات في مبنى واحد",
        caseHighlights: [
          { title: "وحدات معيارية", text: "وحدة طهي 20 م² لكل علامة." },
          { title: "تبريد مشترك", text: "تبريد وتجميد مركزي متاح لكل الوحدات." },
          { title: "التوسّع", text: "تصميم قابل للتكرار للموقع 2 و 3 خلال 4 أسابيع لكل." },
        ],
        caseStats: [{ value: "8", label: "وحدات" }, { value: "4 أسابيع", label: "لكل موقع" }, { value: "6", label: "علامات" }],
        ctaTitle: "توسّع مطبخاً سحابياً؟",
        ctaSubtitle: "اطلب تصميم وحدة قابل للتكرار عبر المواقع.",
      },
      central_kitchen: {
        h1: "مطابخ مركزية لمشغلي المواقع المتعددة",
        subtitle: "إنتاج طهي-تبريد ولوجستيات توزيع وتوزين لسلاسل المطاعم ومجموعات F&B.",
        delivers: ["خطوط طهي دفعية", "خط طهي-تبريد", "مبردات ومجمدات صدمة", "تعبئة فراغية", "مخزن بارد وتوزيع", "عربات توزيع"],
        caseTitle: "مطبخ مركزي لسلسلة مطاعم",
        caseSub: "يغذي 24 منفذاً في الإمارات",
        caseHighlights: [
          { title: "الحجم", text: "5 طن طعام محضر يومياً." },
          { title: "طهي-تبريد", text: "طهي-تبريد 48 ساعة مع تعبئة فراغية." },
          { title: "التوزيع", text: "شاحنات مبردة تغذي 24 منفذاً يومياً." },
        ],
        caseStats: [{ value: "24", label: "منفذ" }, { value: "5 طن", label: "يومياً" }, { value: "48س", label: "صلاحية" }],
        ctaTitle: "تبني مطبخاً مركزياً؟",
        ctaSubtitle: "نخطط طاقة الإنتاج والسلسلة الباردة ولوجستيات التوصيل.",
      },
    },
    businessAccount: {
      eyebrow: "حساب تجاري B2B",
      title: "افتح حساباً تجارياً مع ماريوت",
      subtitle: "للمجموعات والسلاسل والمشترين المتكررين — احصل على شروط ائتمان ومدير حساب مخصص وتوصيل ذي أولوية ومراجعات فصلية.",
      chip1: "شروط ائتمانية",
      chip2: "مدير حساب مخصص",
      chip3: "أسعار كميات",
      card1Label: "ائتمان حتى",
      card1Value: "60 يوم",
      card2Label: "خصم الكميات",
      card2Value: "حتى 22%",
      benefitsEyebrow: "لماذا الحساب التجاري",
      benefitsTitle: "مزايا تنمو مع أعمالك",
      benefits: [
        { title: "شروط ائتمان مرنة", text: "شروط 15 أو 30 أو 60 يوم تُعتمد بعد إعداد الحساب." },
        { title: "مدير مخصص", text: "نقطة اتصال واحدة للطلبات والخدمة وما بعد البيع." },
        { title: "أسعار الكميات", text: "خصومات تصاعدية بحسب الحجم التجاري السنوي." },
        { title: "توصيل ذو أولوية", text: "طلباتك تسبق الطابور مع تسليم بنفس الأسبوع في كل الإمارات." },
        { title: "مراجعات فصلية", text: "مراجعة أعمال ربع سنوية لالتقاط أنماط الاستهلاك والاحتياجات المستقبلية." },
        { title: "فوترة موحدة", text: "فواتير شهرية موحدة عبر جميع فروعك." },
      ],
      formEyebrow: "طلب حساب تجاري",
      formTitle: "افتح حسابك",
      formSubtitle: "يتم التحقق خلال 48 ساعة عمل. يمكن إرسال المستندات لاحقاً.",
      section1: "بيانات الشركة",
      section2: "جهة الاتصال الأساسية",
      section3: "الملف التجاري",
      companyName: "الاسم القانوني للشركة",
      businessType: "نوع النشاط",
      businessTypes: {
        restaurant_group: "مجموعة مطاعم",
        hotel_chain: "سلسلة فنادق",
        catering: "تموين / خدمات طعام",
        cloud_kitchen: "مطبخ سحابي",
        supermarket: "سوبرماركت / تجزئة",
        bakery_chain: "سلسلة مخابز",
        other: "غير ذلك",
      },
      tradeLicense: "رقم الرخصة التجارية",
      vatNumber: "رقم القيمة المضافة (TRN)",
      emirate: "الإمارة المسجّلة",
      contactName: "المسؤول عن التواصل",
      contactRole: "المنصب / الوظيفة",
      contactRolePlaceholder: "مثال: مدير المشتريات",
      phone: "الهاتف / واتساب",
      email: "البريد الإلكتروني للأعمال",
      monthlyVolume: "الحجم الشهري المتوقع (درهم)",
      monthlyVolumes: {
        under_20k: "أقل من 20,000 درهم",
        "20k_100k": "20,000 – 100,000 درهم",
        "100k_500k": "100,000 – 500,000 درهم",
        over_500k: "أكثر من 500,000 درهم",
      },
      creditTerms: "شروط الائتمان المفضلة",
      creditTermsOptions: {
        prepaid: "دفع مسبق",
        net_15: "15 يوم",
        net_30: "30 يوم",
        net_60: "60 يوم",
      },
      authorizedSignatory: "المفوَّض بالتوقيع (اختياري)",
      authorizedSignatoryHint: "الاسم الكامل للمفوَّض بالتوقيع",
      additionalNotes: "ملاحظات إضافية",
      submit: "إرسال الطلب",
      formFooter: "سيُطلب منك الرخصة التجارية وشهادة القيمة المضافة عبر البريد الإلكتروني بعد الإرسال.",
    },
    consultation: {
      eyebrow: "استشارة مطبخ",
      title: "احجز استشارة مجانية وزيارة موقع",
      subtitle: "60 دقيقة مع مستشار مطابخ خبير. زيارة موقع أو مكالمة فيديو أو هاتفية — الأنسب لمرحلة مشروعك.",
      bullets: [
        "مجانية وبدون التزام",
        "متاحة في كل الإمارات السبع",
        "مقترحات تخطيط أولية خلال الزيارة",
        "ملاحظات مكتوبة نُرسلها خلال 48 ساعة",
      ],
      demoLabel1: "أقرب موعد",
      demoValue1: "هذا الأسبوع",
      demoLabel2: "الاستشارة مؤكدة",
      demoValue2: "الأربعاء · 11:00 صباحاً · مارينا، دبي",
      demoLabel3: "زمن الاستجابة",
      demoValue3: "< 4 ساعات",
      steps: [
        { title: "تحجز أنت", text: "اختر التاريخ والوقت. زيارة موقع أو فيديو أو مكالمة — أنت تختار." },
        { title: "نؤكد نحن", text: "يؤكد مستشار خلال 4 ساعات ويرسل ملف الاجتماع." },
        { title: "نلتقي ونخطط", text: "نجول في المساحة ونناقش الانسيابية ثم نرسل تقريراً مكتوباً." },
      ],
      formEyebrow: "احجز موعدك",
      formTitle: "جدولة الاستشارة",
      formSubtitle: "سنؤكد موعدك خلال 4 ساعات عمل.",
      visitType: "نوع الاستشارة",
      visitTypes: {
        site_visit: "زيارة موقع",
        video_call: "مكالمة فيديو",
        phone_call: "مكالمة هاتفية",
      },
      name: "الاسم",
      phone: "الهاتف / واتساب",
      email: "البريد الإلكتروني",
      projectStage: "مرحلة المشروع",
      projectStages: {
        idea: "مجرد فكرة",
        concept: "مرحلة المفهوم",
        design: "التصميم جارٍ",
        build: "بناء / تشطيب",
        operating: "تشغيل حالي",
      },
      emirate: "الإمارة",
      address: "عنوان الموقع",
      addressHint: "المبنى، الشارع، المنطقة",
      preferredDate: "التاريخ المفضل",
      preferredTime: "الوقت المفضل",
      times: {
        morning: "صباحاً (9 - 12)",
        afternoon: "ظهراً (12 - 4)",
        evening: "مساءً (4 - 8)",
      },
      notes: "ما الذي يمكننا تجهيزه مسبقاً؟",
      notesHint: "مفهوم القائمة، حجم المطبخ، معدات موجودة، إلخ.",
      submit: "احجز الاستشارة",
      formFooter: "الحجز مجاني. لا التزام بشراء أي شيء.",
    },
    opening: {
      eyebrow: "افتتاح مطعم / كافيه",
      title: "من الرؤية إلى يوم الافتتاح — بالكامل",
      subtitle: "متخصصو الإطلاق يرافقونك عبر التراخيص والتصميم والمعدات وتدريب الفريق والتسويق حتى يفتح مشروعك في وقته وبميزانيته.",
      chips: [
        "خطة من الفكرة للافتتاح",
        "تنسيق التراخيص",
        "باقات معدات",
        "توظيف وتدريب الفريق",
        "تسويق الافتتاح الناعم",
      ],
      pillarsEyebrow: "دعم من الألف إلى الياء",
      pillarsTitle: "أربعة أعمدة لافتتاح ناجح",
      pillars: [
        { title: "التصميم والتخطيط", text: "مخطط المطبخ والصالة مُصمَّم هندسياً لمفهومك." },
        { title: "باقات المعدات", text: "معدات مجمّعة من 40+ علامة موثوقة." },
        { title: "التوصيل والتركيب", text: "لوجستيات وتركيب واختبار وتسليم." },
        { title: "التدريب والإطلاق", text: "تدريب الفريق وتجارب ما قبل الافتتاح ودعم الافتتاح الناعم." },
      ],
      formEyebrow: "طلب دعم افتتاح",
      formTitle: "أخبرنا عن افتتاحك",
      formSubtitle: "متخصص الإطلاق سيتواصل معك خلال 24 ساعة.",
      section1: "المفهوم",
      section2: "الاستثمار والمرحلة",
      section3: "الاتصال",
      conceptName: "اسم المفهوم / العلامة",
      conceptNameHint: "مثال: مطعم التين الأزرق",
      conceptType: "نوع المفهوم",
      conceptTypes: {
        fine_dining: "فاين داينينج",
        casual_dining: "مطعم عادي",
        fast_casual: "فاست كاجوال",
        cafe: "كافيه / قهوة",
        cloud_kitchen: "مطبخ سحابي",
        bakery: "مخبز / معجنات",
        food_truck: "فود ترك",
        other: "أخرى",
      },
      cuisine: "المطبخ / الطابع",
      cuisineHint: "مثال: إيطالي، شامي حديث",
      seats: "عدد المقاعد / السعة",
      targetDate: "تاريخ الافتتاح المستهدف",
      location: "الموقع",
      investment: "نطاق الاستثمار (درهم)",
      investmentRanges: {
        under_150k: "أقل من 150,000",
        "150k_500k": "150,000 – 500,000",
        "500k_1m": "500,000 – 1,000,000",
        "1m_3m": "1M – 3M",
        over_3m: "أكثر من 3M",
      },
      currentStage: "المرحلة الحالية",
      stages: {
        idea: "فكرة",
        concept: "مفهوم",
        design: "تصميم",
        fitout: "تشطيب",
        pre_opening: "ما قبل الافتتاح",
      },
      needsLabel: "بماذا تحتاج المساعدة؟",
      needs: {
        license: "التراخيص",
        design: "التصميم",
        equipment: "المعدات",
        install: "التركيب",
        training: "تدريب الفريق",
        marketing: "التسويق",
      },
      contactName: "الاسم",
      phone: "الهاتف / واتساب",
      email: "البريد الإلكتروني",
      notes: "أي شي آخر نحتاج معرفته؟",
      notesHint: "شركاء، جمهور مستهدف، تحديات تريد إخبارنا بها.",
      submit: "اطلب دعم الافتتاح",
      formFooter: "ستستلم خارطة طريق الافتتاح وتقدير استثماري مبدئي خلال 24 ساعة.",
    },
    urgent: {
      eyebrow: "عاجل · استجابة بمدة محددة",
      title: "المطبخ متوقف؟ نتحرك بسرعة.",
      subtitle: "عروض أسعار في نفس اليوم، توصيل خلال 48 ساعة للمعدات المتوفرة، واستدعاءات هندسية ذات أولوية في كل الإمارات.",
      whatsappNow: "واتساب فوري",
      callNow: "اتصل الآن",
      slaLabel: "التزامنا",
      sla: [
        { label: "الاستجابة", value: "< 30 دقيقة" },
        { label: "عرض السعر", value: "< 4 ساعات" },
        { label: "التسليم (متوفر)", value: "24–48 ساعة" },
        { label: "استدعاء مهندس", value: "نفس اليوم" },
      ],
      problemsEyebrow: "ماذا نحل",
      problemsTitle: "أشهر الحالات العاجلة التي نتعامل معها",
      problems: [
        { title: "معدات معطلة", text: "إصلاح أو استبدال أو تأجير وحدة مؤقتة." },
        { title: "توصيل سريع", text: "أولوية إرسال المعدات المتوفرة لكل الإمارات." },
        { title: "تركيب طارئ", text: "تركيب وحدة بديلة حرجة في نفس اليوم." },
        { title: "قطع غيار", text: "قطع أصلية من مستودعنا." },
      ],
      formEyebrow: "طلب عاجل",
      formTitle: "سجّل طلبك العاجل",
      formSubtitle: "أسرع استجابة عبر الهاتف + واتساب. الصور تساعدنا كثيراً.",
      urgency: "ما مستوى الاستعجال؟",
      urgencies: {
        same_day: "نفس اليوم",
        next_48h: "خلال 48 ساعة",
        this_week: "هذا الأسبوع",
      },
      problem: "نوع المشكلة",
      problems_options: {
        downtime: "معدات معطلة",
        delivery: "توصيل عاجل",
        installation: "تركيب عاجل",
        replacement: "وحدة بديلة",
        spare_parts: "قطع غيار",
        other: "أخرى",
      },
      equipmentType: "نوع المعدات (إن أمكن)",
      equipmentTypeHint: "مثال: فرن كومبي، ثلاجة ووك-إن",
      description: "ماذا حدث / ما الذي تحتاجه",
      descriptionHint: "صف المشكلة بأسطر قليلة — سنتابع الأسئلة عبر واتساب.",
      photo: "صورة المعدات (مفضّل)",
      photoHint: "ارفع صورة (PDF/JPG/PNG، حتى 10 MB)",
      contactSection: "الاتصال والموقع",
      contactName: "الاسم",
      businessName: "اسم المنشأة",
      phone: "الهاتف / واتساب",
      email: "البريد الإلكتروني",
      emirate: "الإمارة",
      submit: "أرسل الطلب العاجل",
      formFooter: "مهندس الاستدعاء سيتواصل معك خلال 30 دقيقة في ساعات العمل.",
    },
    about: {
      eyebrow: "من نحن", title: "عن ماريوت لمعدات المطابخ",
      body: "ماريوت لمعدات المطابخ هي مورد احترافي لمعدات المطابخ التجارية وحلول التبريد وتصنيع الستانلس ستيل ومعدات الغسيل ودعم المشاريع للمطاعم والمقاهي والفنادق والسوبرماركت والمخابز وشركات التموين والمستشفيات والمنتجعات ومنشآت خدمات الطعام التجارية.",
      visionTitle: "رؤيتنا",
      vision: "أن نصبح من أبرز موردي معدات المطابخ التجارية وحلول المشاريع في الإمارات والخليج من خلال تقديم منتجات موثوقة وخدمة احترافية وحلول معدات متكاملة لكل أنواع منشآت خدمات الطعام.",
      missionTitle: "مهمتنا",
      mission: "مساعدة عملائنا على بناء مطابخ فعّالة وموثوقة واحترافية من خلال تقديم معدات عالية الجودة وعروض أسعار سريعة وماركات موثوقة ودعم مشاريع كامل من التخطيط حتى التوريد.",
      whatWeDoTitle: "ما نقوم به",
      whatWeDo: [
        "توريد معدات المطابخ التجارية وخطوط الطهي",
        "التبريد التجاري — غرف التبريد والمبردات الصدمية ومنضدات العرض",
        "تصنيع ستانلس ستيل مخصص (درجة 304 و 430)",
        "معدات الغسيل للفنادق والمستشفيات والتطبيقات الصناعية",
        "مشاريع متكاملة — تصميم وتوريد وتركيب وتشغيل",
        "خدمات ما بعد البيع وقطع الغيار وعقود الصيانة",
      ],
      sectorsTitle: "القطاعات المستهدفة",
      strengthsTitle: "نقاط قوتنا",
      strengths: [
        "شراكات مباشرة مع أبرز المصنّعين العالميين",
        "فريق هندسة وتصميم داخلي متكامل",
        "مستودع في الإمارات مع توفر مخزون فوري",
        "مبيعات ودعم فني بلغات متعددة",
      ],
    },
    projects: {
      eyebrow: "مشاريعنا", title: "مشاريعنا", subtitle: "أعمال مختارة نفذناها في الإمارات.",
      filterAll: "الكل", empty: "لا توجد مشاريع في هذه الفئة بعد.", viewDetails: "عرض المشروع",
      location: "الموقع", emirate: "الإمارة", completed: "تاريخ الإنجاز", client: "العميل",
      scope: "نطاق العمل", equipment: "المعدات الموردة", brandsUsed: "الماركات المستخدمة",
      gallery: "معرض الصور", similar: "اطلب مشروعاً مشابهاً", backToAll: "العودة لجميع المشاريع",
    },
    brands: {
      eyebrow: "ماركاتنا العالمية", title: "ماركاتنا العالمية",
      subtitle: "توريد معتمد من أكثر المصنّعين ثقة في العالم.",
      country: "البلد", productCategories: "فئات المنتجات", featuredProducts: "منتجات مميزة",
      downloadCatalog: "تحميل الكتالوج", requestQuote: "طلب عرض سعر", backToAll: "العودة لجميع الماركات",
    },
    branches: {
      eyebrow: "فروعنا", title: "فروعنا",
      subtitle: "نخدم عملاءنا في جميع أنحاء الإمارات بفرق محلية متخصصة.",
      workingHours: "ساعات العمل", phone: "الهاتف", whatsapp: "واتساب",
      email: "البريد الإلكتروني", address: "العنوان", viewBranch: "عرض الفرع",
      viewOnMap: "افتح في خرائط جوجل", backToAll: "العودة لجميع الفروع",
    },
    blog: {
      eyebrow: "المدونة", title: "أفكار وأدلة",
      subtitle: "نصائح متخصصة حول معدات المطابخ وتخطيط المشاريع والصيانة.",
      readMore: "قراءة المقال", by: "بواسطة", published: "نُشر في",
      backToAll: "العودة لجميع المقالات", relatedTitle: "مقالات ذات صلة", empty: "لا توجد مقالات بعد.",
    },
    contact: {
      eyebrow: "تواصل معنا", title: "اتصل بنا",
      subtitle: "تواصل معنا عبر القناة التي تفضّلها — عادةً نرد خلال ساعات قليلة.",
      whatsappCta: "دردشة عبر واتساب", callCta: "اتصل بنا", emailCta: "راسلنا بالبريد",
    },
    quotation: {
      eyebrow: "اطلب عرض سعر", title: "اطلب عرض سعر مجاني",
      subtitle: "أخبرنا عن مشروعك. أرفق قائمة الكميات أو مخطط المطبخ للحصول على عرض دقيق.",
      name: "الاسم الكامل", phone: "الهاتف / واتساب", projectType: "نوع المشروع",
      emirate: "الإمارة", message: "وصف المشروع", companyName: "اسم الشركة",
      email: "البريد الإلكتروني", budget: "الميزانية التقريبية (درهم)", expectedDate: "تاريخ البدء المتوقع",
      website: "الموقع الإلكتروني للشركة", preferredContact: "طريقة التواصل المفضلة",
      uploadLabel: "ارفع قائمة الكميات أو المخطط", uploadHint: "PDF أو JPG أو PNG — بحد أقصى 10 ميجابايت",
      required: "مطلوب", optional: "اختياري",
      submit: "إرسال الطلب", submitting: "جارٍ الإرسال...",
      success: "شكراً لك. تم استلام طلبك وسيتواصل معك فريقنا قريباً.",
      error: "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
      contact: { whatsapp: "واتساب", call: "اتصال هاتفي", email: "بريد إلكتروني" },
      dates: { immediately: "فوراً", "1month": "خلال شهر", "3months": "خلال 3 أشهر", "6months": "خلال 6 أشهر", not_sure: "غير محدد بعد" },
      referenceLabel: "مهتم بمشروع مشابه لـ:",
    },
    emirates: {
      dubai: "دبي", abu_dhabi: "أبوظبي", sharjah: "الشارقة", ajman: "عجمان",
      ras_al_khaimah: "رأس الخيمة", fujairah: "الفجيرة", umm_al_quwain: "أم القيوين",
      al_ain: "العين", other: "أخرى",
    },
    statuses: {
      new: "جديد", contacted: "تم التواصل", quotation_sent: "تم إرسال العرض",
      waiting_customer: "بانتظار العميل", approved: "معتمد",
      rejected: "مرفوض", closed: "مغلق",
    },
    footer: {
      about: "ماريوت لمعدات المطابخ — مورد احترافي لمعدات المطابخ التجارية والتبريد وتصنيع الستانلس ستيل وحلول الغسيل في الإمارات والخليج.",
      quickLinks: "روابط سريعة", contact: "تواصل", followUs: "تابعنا", rights: "جميع الحقوق محفوظة.",
    },
    admin: {
      login: "دخول الإدارة", email: "البريد الإلكتروني", password: "كلمة المرور", signIn: "دخول",
      dashboard: "لوحة الإدارة", logout: "خروج",
      quotations: "طلبات عروض الأسعار", projects: "المشاريع", brands: "الماركات",
      branches: "الفروع", blog: "المدونة",
      status: "الحالة", assignedStaff: "الموظف المسؤول", notes: "ملاحظات",
      loginError: "بريد أو كلمة مرور غير صحيحة",
    },
    design: {
      eyebrow: "تخطيط وتصميم المطابخ التجارية",
      title: "من الفكرة إلى مطبخ متكامل جاهز للعمل",
      subtitle: "تصميم ثلاثي الأبعاد، مخططات هندسية دقيقة، وأفضل العلامات العالمية — يرافقك فريقنا من أول رسم وحتى أول طبق.",
      cta1: "ابدأ استشارتك",
      cta2: "تحدث مع خبير",
      badge1: "استشارة أولى مجانية",
      badge2: "تصميم ثلاثي الأبعاد",
      badge3: "تركيب وضمان",
      stats: [
        { value: "3D", label: "تصميم حي" },
        { value: "500+", label: "مشروع منجز" },
        { value: "20+", label: "عاماً من الخبرة" },
        { value: "40+", label: "علامة عالمية" },
      ],
      stagesEyebrow: "من الورقة إلى الواقع",
      stagesTitle: "نخطّط، نصمّم، ننفّذ",
      stagesSubtitle: "مخططات هندسية دقيقة، نماذج ثلاثية الأبعاد واقعية، ثم مطبخ متكامل بين يديك.",
      stages: [
        { title: "مخطط هندسي", text: "مخططات مطابقة للأنظمة وجداول تجهيزات دقيقة." },
        { title: "تصميم ثلاثي الأبعاد", text: "تجوّل في مطبخك قبل تركيب أي قطعة." },
        { title: "تنفيذ متكامل", text: "توريد وتركيب وتشغيل — جاهز للعمل." },
      ],
      viewer: {
        eyebrow: "معاينة تفاعلية ثلاثية الأبعاد",
        title: "استكشف مطبخاً حقيقياً — نموذج ثلاثي الأبعاد حي",
        subtitle: "دوران حر حول التخطيط الكامل، أو تجوّل بين التجهيزات. تجربة هندسية غامرة مبنية على نموذج حقيقي.",
        tag1: "تجربة تفاعلية",
        tag2: "نموذج 3D حقيقي",
        hint: "اسحب للدوران · مرّر للتكبير · اضغط أزرار العرض لتغيير الزاوية",
      },
      sectorsEyebrow: "خبرة قطاعية",
      sectorsTitle: "مشاريع نخطط لها ونجهّزها",
      sectorsSubtitle: "خبرة متخصصة في كل قطاع من قطاعات الضيافة والأغذية.",
      processEyebrow: "كيف نعمل",
      processTitle: "خمس خطوات نحو مطبخك المثالي",
      process: [
        { title: "الاستكشاف والاستشارة", text: "ندرس مفهومك وقائمتك ومساحتك وطاقتك الإنتاجية لتحديد مسار العمل الأمثل للمطبخ." },
        { title: "التصميم ثلاثي الأبعاد", text: "مخططات ثنائية وثلاثية الأبعاد مصممة هندسياً للنظافة وانسيابية العمل والمطابقة للأنظمة." },
        { title: "اختيار التجهيزات", text: "اختيار مدروس للتجهيزات من أكثر من 40 علامة عالمية موثوقة بما يناسب ميزانيتك." },
        { title: "التوريد والتركيب", text: "الخدمات اللوجستية والتجهيز وتنسيق الأعمال الكهروميكانيكية والتركيب الاحترافي في الموقع." },
        { title: "التشغيل والدعم", text: "الاختبار والتسليم للطاقم والضمانات والصيانة المستمرة وقطع الغيار." },
      ],
      whyEyebrow: "لماذا ماريوت",
      whyTitle: "معيار لا يستطيع المنافسون مجاراته",
      whySubtitle: "نجمع التصميم الهندسي والتوريد المعتمد والتركيب الاحترافي تحت سقف واحد، من أول رسم وحتى أول طبق.",
      whyItems: [
        { title: "شريك واحد مسؤول", text: "فريق واحد يتولى التصميم والتوريد والتركيب — دون تبادل للمسؤوليات بين الموردين." },
        { title: "علامات أصلية وضمانات", text: "توزيع معتمد مع ضمانات المصنّعين وخدمة ما بعد البيع المعتمدة." },
        { title: "تسليم في الوقت والميزانية", text: "جداول زمنية وأسعار شفافة محددة منذ مرحلة التخطيط." },
        { title: "حلول متكاملة", text: "من مساحة فارغة إلى مطبخ تشغيلي متكامل وجاهز للعمل." },
      ],
      formEyebrow: "ابدأ الآن",
      formTitle: "اطلب استشارة وتخطيط مشروعك",
      formSubtitle: "أخبرنا عن مشروعك وسيتواصل معك أحد خبراء التخطيط خلال 24 ساعة عمل.",
      fields: {
        projectType: "نوع المشروع",
        name: "الاسم الكامل",
        companyName: "اسم المنشأة / الشركة",
        phone: "رقم الهاتف",
        email: "البريد الإلكتروني",
        emirate: "المدينة / الإمارة",
        area: "المساحة التقريبية (م²)",
        budget: "الميزانية التقديرية",
        timeframe: "الإطار الزمني",
        details: "تفاصيل إضافية عن مشروعك",
      },
      budgets: {
        under_50k: "أقل من 50,000 درهم",
        "50k_150k": "50,000 – 150,000 درهم",
        "150k_500k": "150,000 – 500,000 درهم",
        "500k_plus": "أكثر من 500,000 درهم",
      },
      timeframes: {
        asap: "في أقرب وقت",
        "1_3_months": "1 – 3 أشهر",
        "3_6_months": "3 – 6 أشهر",
        planning: "مرحلة التخطيط",
      },
      formSubmit: "أرسل طلب الاستشارة",
      formNote: "بياناتك تُستخدم فقط للتواصل بخصوص مشروعك.",
      formSuccess: "شكراً لك. سيتواصل معك أحد خبراء التخطيط خلال 24 ساعة عمل.",
      faqEyebrow: "أسئلة شائعة",
      faqTitle: "إجابات سريعة",
      faq: [
        { q: "هل تقدمون استشارة مبدئية مجانية؟", a: "نعم، الاستشارة الأولى ومقترح المخطط المبدئي مجانيان تماماً ودون أي التزام." },
        { q: "ما المناطق التي تخدمونها؟", a: "نقوم بالتوريد والتركيب في جميع إمارات الدولة السبع، مع فروع تدعم المنطقة الأوسع." },
        { q: "هل تعملون مع مساحتنا ومقاولنا الحالي؟", a: "بالتأكيد. ننسّق مع مهندسك المعماري والمقاول وفريق الأعمال الكهروميكانيكية للتكامل بسلاسة." },
        { q: "كم يستغرق المشروع عادةً؟", a: "يستغرق التصميم أسبوعاً إلى أسبوعين، والتوريد والتركيب الكامل من 3 إلى 8 أسابيع حسب الحجم." },
      ],
      finalCtaTitle: "جاهز لبناء مطبخ أحلامك؟",
      finalCtaSubtitle: "استشارة أولى مجانية ومخطط مبدئي دون أي التزام.",
      finalCta: "ابدأ الآن مجاناً",
    },
  },
};
